export const reg_bbox = {
  "AD": {
    "bbox": [
      1.4078,
      42.4288,
      1.7869,
      42.6559
    ]
  },
  "SK": {
    "bbox": [
      16.8332,
      47.7312,
      22.5657,
      49.6138
    ]
  },
  "AT": {
    "bbox": [
      9.5307,
      46.3723,
      17.1608,
      49.0205
    ]
  },
  "HU": {
    "bbox": [
      16.1139,
      45.7371,
      22.8977,
      48.5853
    ]
  },
  "GE": {
    "bbox": [
      41.2902,
      41.0551,
      46.7365,
      43.257
    ]
  },
  "VA": {
    "bbox": [
      12.4458,
      41.9002,
      12.4584,
      41.9074
    ]
  },
  "PL": {
    "bbox": [
      14.0696,
      49.002,
      24.1458,
      55.0361
    ]
  },
  "KH": {
    "bbox": [
      102.3338,
      9.4111,
      107.6277,
      14.6904
    ]
  },
  "LA": {
    "bbox": [
      100.0843,
      13.9097,
      107.635,
      22.5087
    ]
  },
  "VN": {
    "bbox": [
      102.1439,
      7.6921,
      114.8573,
      23.3927
    ]
  },
  "DK": {
    "bbox": [
      7.7153,
      54.4517,
      15.5531,
      57.9524
    ]
  },
  "MM": {
    "bbox": [
      92.1729,
      9.5261,
      101.1701,
      28.5478
    ]
  },
  "DE": {
    "bbox": [
      5.8663,
      47.2701,
      15.0419,
      55.0992
    ]
  },
  "CZ": {
    "bbox": [
      12.0906,
      48.5518,
      18.8593,
      51.0557
    ]
  },
  "CH": {
    "bbox": [
      5.9559,
      45.818,
      10.4923,
      47.8085
    ]
  },
  "BE": {
    "bbox": [
      2.3889,
      49.497,
      6.4081,
      51.5508
    ]
  },
  "SE": {
    "bbox": [
      10.5935,
      55.1371,
      24.1777,
      69.06
    ]
  },
  "FO": {
    "bbox": [
      -8.1188,
      61.1368,
      -5.8255,
      62.5958
    ]
  },
  "AL": {
    "bbox": [
      19.001,
      39.6404,
      21.0574,
      42.6611
    ]
  },
  "MK": {
    "bbox": [
      20.4529,
      40.8537,
      23.0341,
      42.3739
    ]
  },
  "ME": {
    "bbox": [
      18.4196,
      41.685,
      20.3529,
      43.5585
    ]
  },
  "FI": {
    "bbox": [
      20.1636,
      59.4727,
      31.5867,
      70.0923
    ]
  },
  "SM": {
    "bbox": [
      12.4033,
      43.8936,
      12.5162,
      43.9921
    ]
  },
  "MD": {
    "bbox": [
      26.6164,
      45.4672,
      30.1637,
      48.4921
    ]
  },
  "BY": {
    "bbox": [
      23.1783,
      51.2627,
      32.7628,
      56.1722
    ]
  },
  "BR": {
    "bbox": [
      -73.9831,
      -33.8694,
      -28.629,
      5.2696
    ]
  },
  "RU": {
    "bbox": [
      -180,
      41.1851,
      180,
      82.0586
    ]
  },
  "UA": {
    "bbox": [
      22.1371,
      45.0532,
      40.2278,
      52.3797
    ]
  },
  "GB": {
    "bbox": [
      -14.0155,
      49.674,
      2.0919,
      61.061
    ]
  },
  "IM": {
    "bbox": [
      -5.1707,
      53.845,
      -3.9654,
      54.5534
    ]
  },
  "IE": {
    "bbox": [
      -11.0134,
      51.222,
      -5.6582,
      55.636
    ]
  },
  "XT": {
    "bbox": [
      28.4915,
      46.5467,
      29.9794,
      48.1824
    ]
  },
  "LV": {
    "bbox": [
      20.601,
      55.6747,
      28.2415,
      58.0856
    ]
  },
  "LT": {
    "bbox": [
      20.6557,
      53.8968,
      26.8355,
      56.4504
    ]
  },
  "EE": {
    "bbox": [
      21.3826,
      57.5093,
      28.21,
      59.9383
    ]
  },
  "AU": {
    "bbox": [
      112.6998,
      -55.3228,
      159.515,
      -9.088
    ]
  },
  "CC": {
    "bbox": [
      96.6116,
      -12.4119,
      97.135,
      -11.6212
    ]
  },
  "ZA": {
    "bbox": [
      16.3335,
      -47.1788,
      38.2899,
      -22.125
    ]
  },
  "SZ": {
    "bbox": [
      30.7908,
      -27.3175,
      32.135,
      -25.7188
    ]
  },
  "RO": {
    "bbox": [
      20.262,
      43.6187,
      30.0454,
      48.2655
    ]
  },
  "EC": {
    "bbox": [
      -92.2072,
      -5.0159,
      -75.1925,
      1.8836
    ]
  },
  "MX": {
    "bbox": [
      -118.5992,
      14.3812,
      -86.4933,
      32.7187
    ]
  },
  "CO": {
    "bbox": [
      -82.1244,
      -4.2294,
      -66.8511,
      16.0496
    ]
  },
  "MN": {
    "bbox": [
      87.7346,
      41.58,
      119.9322,
      52.1496
    ]
  },
  "US": {
    "bbox": [
      -180,
      18.8655,
      180,
      71.589
    ]
  },
  "CL": {
    "bbox": [
      -109.6796,
      -56.725,
      -66.0753,
      -17.4984
    ]
  },
  "RW": {
    "bbox": [
      28.8617,
      -2.8398,
      30.8991,
      -1.0474
    ]
  },
  "TR": {
    "bbox": [
      25.5656,
      35.8059,
      44.8177,
      42.297
    ]
  },
  "KG": {
    "bbox": [
      69.265,
      39.1727,
      80.2296,
      43.2669
    ]
  },
  "BT": {
    "bbox": [
      88.7465,
      26.7017,
      92.1252,
      28.2474
    ]
  },
  "NP": {
    "bbox": [
      80.0571,
      26.3478,
      88.2015,
      30.4715
    ]
  },
  "BD": {
    "bbox": [
      88.0079,
      20.3679,
      92.6802,
      26.6383
    ]
  },
  "JO": {
    "bbox": [
      34.8844,
      29.1834,
      39.2999,
      33.3735
    ]
  },
  "SY": {
    "bbox": [
      35.4714,
      32.3114,
      42.3746,
      37.3187
    ]
  },
  "LB": {
    "bbox": [
      34.8826,
      33.055,
      36.625,
      34.6921
    ]
  },
  "BG": {
    "bbox": [
      22.3571,
      41.2354,
      28.8875,
      44.2155
    ]
  },
  "GR": {
    "bbox": [
      19.1128,
      34.7189,
      29.6838,
      41.7489
    ]
  },
  "KP": {
    "bbox": [
      124.0924,
      37.5833,
      130.8861,
      43.009
    ]
  },
  "DZ": {
    "bbox": [
      -8.6689,
      18.9681,
      11.9973,
      37.2962
    ]
  },
  "TN": {
    "bbox": [
      7.522,
      30.2291,
      11.8801,
      37.7612
    ]
  },
  "LY": {
    "bbox": [
      9.3911,
      19.5,
      25.3771,
      33.3546
    ]
  },
  "MR": {
    "bbox": [
      -17.2381,
      14.721,
      -4.8333,
      27.3149
    ]
  },
  "GM": {
    "bbox": [
      -17.0224,
      13.0558,
      -13.7978,
      13.8253
    ]
  },
  "SN": {
    "bbox": [
      -17.7499,
      12.2403,
      -11.346,
      16.692
    ]
  },
  "GW": {
    "bbox": [
      -16.8975,
      10.6514,
      -13.6349,
      12.6862
    ]
  },
  "SL": {
    "bbox": [
      -13.5003,
      6.755,
      -10.2717,
      10
    ]
  },
  "GN": {
    "bbox": [
      -15.5681,
      7.1906,
      -7.6379,
      12.6756
    ]
  },
  "CI": {
    "bbox": [
      -8.6015,
      4.1621,
      -2.4949,
      10.7402
    ]
  },
  "LR": {
    "bbox": [
      -11.6081,
      4.1556,
      -7.3673,
      8.5519
    ]
  },
  "GH": {
    "bbox": [
      -3.2608,
      4.5393,
      1.2733,
      11.1749
    ]
  },
  "TG": {
    "bbox": [
      -0.144,
      5.9265,
      1.8087,
      11.1395
    ]
  },
  "BF": {
    "bbox": [
      -5.5132,
      9.4105,
      2.409,
      15.084
    ]
  },
  "BJ": {
    "bbox": [
      0.7767,
      6.0399,
      3.8451,
      12.4092
    ]
  },
  "ML": {
    "bbox": [
      -12.2403,
      10.1478,
      4.2674,
      25.0011
    ]
  },
  "NE": {
    "bbox": [
      0.169,
      11.6936,
      15.9967,
      23.5172
    ]
  },
  "NG": {
    "bbox": [
      2.6769,
      4.0691,
      14.678,
      13.8856
    ]
  },
  "SD": {
    "bbox": [
      21.8144,
      8.6853,
      39.0576,
      22.2249
    ]
  },
  "CF": {
    "bbox": [
      14.4148,
      2.2229,
      27.4665,
      11.0014
    ]
  },
  "GQ": {
    "bbox": [
      5.4173,
      -1.6732,
      11.4114,
      3.989
    ]
  },
  "GA": {
    "bbox": [
      8.5002,
      -4.1269,
      14.529,
      2.3193
    ]
  },
  "CG": {
    "bbox": [
      11.0436,
      -5.1491,
      18.6436,
      3.7131
    ]
  },
  "CD": {
    "bbox": [
      12.0391,
      -13.459,
      31.3057,
      5.392
    ]
  },
  "UG": {
    "bbox": [
      29.5734,
      -1.4823,
      35.0003,
      4.2341
    ]
  },
  "KE": {
    "bbox": [
      33.9097,
      -4.8995,
      41.9068,
      4.62
    ]
  },
  "SO": {
    "bbox": [
      40.9892,
      -1.8032,
      51.6178,
      12.1889
    ]
  },
  "ET": {
    "bbox": [
      32.9976,
      3.3974,
      47.9824,
      14.8943
    ]
  },
  "DJ": {
    "bbox": [
      41.7713,
      10.915,
      43.6579,
      12.7923
    ]
  },
  "CM": {
    "bbox": [
      8.3822,
      1.6518,
      16.1911,
      13.0833
    ]
  },
  "NA": {
    "bbox": [
      11.528,
      -28.9694,
      25.2617,
      -16.9635
    ]
  },
  "AO": {
    "bbox": [
      11.461,
      -18.0394,
      24.0876,
      -4.3458
    ]
  },
  "BI": {
    "bbox": [
      29.0007,
      -4.4693,
      30.8498,
      -2.3097
    ]
  },
  "TZ": {
    "bbox": [
      29.327,
      -11.7613,
      40.6584,
      -0.9855
    ]
  },
  "ZM": {
    "bbox": [
      21.9991,
      -18.0762,
      33.7089,
      -8.2749
    ]
  },
  "ZW": {
    "bbox": [
      25.2373,
      -22.4241,
      33.0684,
      -15.6097
    ]
  },
  "MZ": {
    "bbox": [
      30.2122,
      -26.9209,
      41.0546,
      -10.3252
    ]
  },
  "MW": {
    "bbox": [
      32.6719,
      -17.1296,
      35.9186,
      -9.3683
    ]
  },
  "UZ": {
    "bbox": [
      55.9986,
      37.1816,
      73.2148,
      45.5907
    ]
  },
  "TJ": {
    "bbox": [
      67.3333,
      36.6711,
      75.154,
      41.0451
    ]
  },
  "KZ": {
    "bbox": [
      46.4932,
      40.5687,
      87.3156,
      55.4422
    ]
  },
  "HR": {
    "bbox": [
      13.2105,
      42.1766,
      19.4473,
      46.555
    ]
  },
  "SI": {
    "bbox": [
      13.3755,
      45.4214,
      16.5968,
      46.8767
    ]
  },
  "TM": {
    "bbox": [
      52.2644,
      35.1291,
      66.6904,
      42.7997
    ]
  },
  "BO": {
    "bbox": [
      -69.645,
      -22.8983,
      -57.453,
      -9.6689
    ]
  },
  "GG": {
    "bbox": [
      -3.0209,
      49.2199,
      -2.0503,
      49.9403
    ]
  },
  "CN": {
    "bbox": [
      73.4997,
      8.665,
      134.7755,
      53.5608
    ]
  },
  "VE": {
    "bbox": [
      -73.353,
      0.6474,
      -59.7707,
      15.9158
    ]
  },
  "VG": {
    "bbox": [
      -64.956,
      18.1055,
      -64.0597,
      18.9504
    ]
  },
  "AR": {
    "bbox": [
      -73.5605,
      -55.1926,
      -53.6375,
      -21.7809
    ]
  },
  "VI": {
    "bbox": [
      -65.1541,
      17.6235,
      -64.5127,
      18.465
    ]
  },
  "UY": {
    "bbox": [
      -58.4948,
      -35.7825,
      -53.0756,
      -30.0854
    ]
  },
  "PY": {
    "bbox": [
      -62.6407,
      -27.6064,
      -54.258,
      -19.2876
    ]
  },
  "SR": {
    "bbox": [
      -58.0712,
      1.8313,
      -53.8601,
      6.2161
    ]
  },
  "GY": {
    "bbox": [
      -61.3827,
      1.171,
      -56.469,
      8.6039
    ]
  },
  "NI": {
    "bbox": [
      -87.8958,
      10.7074,
      -82.4767,
      15.0903
    ]
  },
  "CR": {
    "bbox": [
      -87.102,
      5.4992,
      -82.4299,
      11.2196
    ]
  },
  "PA": {
    "bbox": [
      -83.0517,
      7.0027,
      -77.1586,
      9.8469
    ]
  },
  "HN": {
    "bbox": [
      -89.3568,
      12.9808,
      -82.1816,
      17.6195
    ]
  },
  "BZ": {
    "bbox": [
      -89.2262,
      15.8857,
      -87.2765,
      18.4959
    ]
  },
  "PE": {
    "bbox": [
      -84.6357,
      -20.1984,
      -68.652,
      -0.0393
    ]
  },
  "PT": {
    "bbox": [
      -31.5575,
      29.8282,
      -6.1892,
      42.1543
    ]
  },
  "ER": {
    "bbox": [
      36.4334,
      12.3548,
      43.3002,
      18.071
    ]
  },
  "IS": {
    "bbox": [
      -25.0135,
      63.0859,
      -12.8046,
      67.353
    ]
  },
  "AF": {
    "bbox": [
      60.5176,
      29.3773,
      74.8899,
      38.4911
    ]
  },
  "IN": {
    "bbox": [
      67.9544,
      6.5531,
      97.3956,
      35.6745
    ]
  },
  "ID": {
    "bbox": [
      94.7717,
      -11.2086,
      141.0194,
      6.2744
    ]
  },
  "IQ": {
    "bbox": [
      38.7926,
      29.0586,
      49.1068,
      37.3807
    ]
  },
  "IR": {
    "bbox": [
      44.0319,
      24.8353,
      63.3333,
      39.7825
    ]
  },
  "YE": {
    "bbox": [
      41.6083,
      11.9085,
      54.7389,
      19
    ]
  },
  "QA": {
    "bbox": [
      50.5675,
      24.4708,
      52.638,
      26.4346
    ]
  },
  "KW": {
    "bbox": [
      46.5527,
      28.5244,
      49.0047,
      30.1038
    ]
  },
  "OM": {
    "bbox": [
      52,
      16.465,
      60.0546,
      26.7027
    ]
  },
  "TL": {
    "bbox": [
      124.034,
      -9.6097,
      127.5434,
      -8.1161
    ]
  },
  "GU": {
    "bbox": [
      144.5634,
      13.1823,
      145.0092,
      13.7062
    ]
  },
  "MP": {
    "bbox": [
      144.8133,
      14.0366,
      146.1544,
      20.6166
    ]
  },
  "PK": {
    "bbox": [
      60.8729,
      23.4342,
      77.1204,
      37.0841
    ]
  },
  "SA": {
    "bbox": [
      34.4572,
      16.29,
      55.6667,
      32.1543
    ]
  },
  "KR": {
    "bbox": [
      124.3727,
      32.9105,
      132.1468,
      38.6177
    ]
  },
  "AE": {
    "bbox": [
      51.4161,
      22.6316,
      56.6024,
      26.1517
    ]
  },
  "DM": {
    "bbox": [
      -61.6869,
      15.0074,
      -61.033,
      15.7872
    ]
  },
  "DO": {
    "bbox": [
      -72.0696,
      17.2702,
      -68.1101,
      21.2929
    ]
  },
  "HT": {
    "bbox": [
      -75.2385,
      17.8209,
      -71.6217,
      20.2912
    ]
  },
  "CU": {
    "bbox": [
      -85.168,
      19.6275,
      -73.919,
      23.4817
    ]
  },
  "PG": {
    "bbox": [
      140.8417,
      -11.8556,
      159.6935,
      -0.5574
    ]
  },
  "AM": {
    "bbox": [
      43.4471,
      38.8405,
      46.6333,
      41.3016
    ]
  },
  "AZ": {
    "bbox": [
      44.7634,
      38.393,
      51.1766,
      41.9647
    ]
  },
  "MT": {
    "bbox": [
      13.936,
      35.5854,
      14.8228,
      36.2825
    ]
  },
  "IT": {
    "bbox": [
      6.6273,
      35.289,
      18.7845,
      47.0921
    ]
  },
  "JE": {
    "bbox": [
      -2.5605,
      48.8712,
      -1.8347,
      49.4596
    ]
  },
  "BH": {
    "bbox": [
      50.2698,
      25.535,
      50.9234,
      26.6872
    ]
  },
  "JP": {
    "bbox": [
      122.7142,
      20.2146,
      154.2055,
      45.7112
    ]
  },
  "PH": {
    "bbox": [
      114.1037,
      4.3833,
      126.8031,
      21.3219
    ]
  },
  "MG": {
    "bbox": [
      42.968,
      -25.784,
      50.6727,
      -11.7329
    ]
  },
  "TW": {
    "bbox": [
      114.2858,
      10.3268,
      122.3283,
      26.4372
    ]
  },
  "CV": {
    "bbox": [
      -25.5731,
      14.6066,
      -22.4548,
      17.4071
    ]
  },
  "KM": {
    "bbox": [
      42.8262,
      -12.9854,
      44.9731,
      -11.1624
    ]
  },
  "MU": {
    "bbox": [
      56.3816,
      -20.7286,
      63.7158,
      -10.1352
    ]
  },
  "ST": {
    "bbox": [
      6.2606,
      -0.2135,
      7.6705,
      1.9258
    ]
  },
  "SC": {
    "bbox": [
      45.9989,
      -10.4649,
      56.4979,
      -3.512
    ]
  },
  "MV": {
    "bbox": [
      72.3554,
      -0.9075,
      73.9701,
      7.3106
    ]
  },
  "SG": {
    "bbox": [
      103.5667,
      1.1285,
      104.5717,
      1.5143
    ]
  },
  "LK": {
    "bbox": [
      79.422,
      5.719,
      82.081,
      10.035
    ]
  },
  "KN": {
    "bbox": [
      -63.0491,
      16.8926,
      -62.3742,
      17.6171
    ]
  },
  "AG": {
    "bbox": [
      -62.5548,
      16.7556,
      -61.4476,
      17.9473
    ]
  },
  "MS": {
    "bbox": [
      -62.4502,
      16.4737,
      -61.936,
      16.8885
    ]
  },
  "BL": {
    "bbox": [
      -63.0664,
      17.6709,
      -62.5844,
      18.1376
    ]
  },
  "BS": {
    "bbox": [
      -80.7002,
      20.706,
      -72.4478,
      27.4735
    ]
  },
  "TC": {
    "bbox": [
      -72.6799,
      20.9553,
      -70.8644,
      22.1631
    ]
  },
  "BB": {
    "bbox": [
      -59.8562,
      12.845,
      -59.2147,
      13.535
    ]
  },
  "VC": {
    "bbox": [
      -61.6646,
      12.3984,
      -60.9088,
      13.5843
    ]
  },
  "GD": {
    "bbox": [
      -62.0073,
      11.7759,
      -61.2095,
      12.6097
    ]
  },
  "LC": {
    "bbox": [
      -61.2856,
      13.5061,
      -60.664,
      14.2725
    ]
  },
  "JM": {
    "bbox": [
      -78.5782,
      16.5899,
      -75.7541,
      18.7256
    ]
  },
  "TT": {
    "bbox": [
      -62.0831,
      9.8732,
      -60.2896,
      11.5628
    ]
  },
  "NZ": {
    "bbox": [
      -179.0592,
      -52.8214,
      179.3644,
      -29.0303
    ]
  },
  "KI": {
    "bbox": [
      -174.7434,
      -11.646,
      177.0491,
      4.9
    ]
  },
  "FJ": {
    "bbox": [
      -180,
      -21.9434,
      180,
      -12.2614
    ]
  },
  "MH": {
    "bbox": [
      160.5911,
      4.3697,
      172.374,
      14.9241
    ]
  },
  "FM": {
    "bbox": [
      137.1344,
      0.8233,
      163.2375,
      10.2933
    ]
  },
  "NR": {
    "bbox": [
      166.71,
      -0.753,
      167.1597,
      -0.303
    ]
  },
  "PW": {
    "bbox": [
      130.9194,
      2.5958,
      134.9295,
      8.4058
    ]
  },
  "HK": {
    "bbox": [
      113.8172,
      22.1367,
      114.5025,
      22.5683
    ]
  },
  "MC": {
    "bbox": [
      7.409,
      43.5165,
      7.533,
      43.7519
    ]
  },
  "XO": {
    "bbox": [
      43.5808,
      42.0228,
      44.6252,
      42.7449
    ]
  },
  "XA": {
    "bbox": [
      39.8845,
      42.4072,
      42.1404,
      43.5864
    ]
  },
  "LI": {
    "bbox": [
      9.4717,
      47.0484,
      9.6357,
      47.2706
    ]
  },
  "CW": {
    "bbox": [
      -69.3673,
      11.777,
      -68.4413,
      12.592
    ]
  },
  "BQ": {
    "bbox": [
      -68.6255,
      11.825,
      -62.7847,
      17.85
    ]
  },
  "AW": {
    "bbox": [
      -70.2696,
      12.2578,
      -69.6612,
      12.823
    ]
  },
  "SX": {
    "bbox": [
      -63.2688,
      17.8062,
      -62.9494,
      18.064
    ]
  },
  "YT": {
    "bbox": [
      44.7437,
      -13.2733,
      45.507,
      -12.379
    ]
  },
  "GF": {
    "bbox": [
      -54.6027,
      2.1109,
      -51.5045,
      5.9839
    ]
  },
  "GI": {
    "bbox": [
      -5.4007,
      36.0588,
      -5.2767,
      36.155
    ]
  },
  "ES": {
    "bbox": [
      -18.3937,
      27.4335,
      4.5919,
      43.9933
    ]
  },
  "GP": {
    "bbox": [
      -62.018,
      15.6444,
      -60.792,
      16.714
    ]
  },
  "FR": {
    "bbox": [
      -5.4518,
      41.2611,
      9.8282,
      51.3056
    ]
  },
  "CA": {
    "bbox": [
      -141.0027,
      41.6766,
      -52.3238,
      83.3362
    ]
  },
  "IL": {
    "bbox": [
      34.2675,
      29.4534,
      35.895,
      33.3356
    ]
  },
  "EG": {
    "bbox": [
      24.6499,
      21.9937,
      37.1154,
      31.8331
    ]
  },
  "SV": {
    "bbox": [
      -90.2209,
      12.9518,
      -87.5971,
      14.451
    ]
  },
  "GT": {
    "bbox": [
      -92.3649,
      13.5634,
      -88.2134,
      17.8166
    ]
  },
  "NU": {
    "bbox": [
      -170.1595,
      -19.3549,
      -169.5647,
      -18.7535
    ]
  },
  "AX": {
    "bbox": [
      19.0832,
      59.4542,
      21.3456,
      60.8767
    ]
  },
  "SS": {
    "bbox": [
      23.4478,
      3.489,
      35.949,
      12.2364
    ]
  },
  "PS": {
    "bbox": [
      34.0547,
      31.2201,
      35.5404,
      32.5489
    ]
  },
  "RS": {
    "bbox": [
      18.815,
      42.2314,
      23.0063,
      46.1903
    ]
  },
  "RE": {
    "bbox": [
      55.0033,
      -21.5904,
      56.0508,
      -20.6728
    ]
  },
  "SB": {
    "bbox": [
      155.3191,
      -13.2424,
      170.3965,
      -4.8128
    ]
  },
  "MO": {
    "bbox": [
      113.5282,
      22.0767,
      113.6301,
      22.217
    ]
  },
  "WS": {
    "bbox": [
      -173.0092,
      -14.2771,
      -171.1929,
      -13.2382
    ]
  },
  "BW": {
    "bbox": [
      19.9986,
      -26.907,
      29.3739,
      -17.7781
    ]
  },
  "MQ": {
    "bbox": [
      -61.4355,
      14.2217,
      -60.6023,
      15.0795
    ]
  },
  "MF": {
    "bbox": [
      -63.3606,
      17.8964,
      -62.7644,
      18.1903
    ]
  },
  "SH": {
    "bbox": [
      -14.6227,
      -40.57,
      -5.4234,
      -7.69
    ]
  },
  "GS": {
    "bbox": [
      -42.3571,
      -59.673,
      -25.8873,
      -53.3471
    ]
  },
  "BM": {
    "bbox": [
      -65.1232,
      32.047,
      -64.411,
      32.5914
    ]
  },
  "IO": {
    "bbox": [
      71.1873,
      -7.4941,
      72.545,
      -5.1857
    ]
  },
  "TH": {
    "bbox": [
      97.3438,
      5.6129,
      105.6368,
      20.4648
    ]
  },
  "XK": {
    "bbox": [
      20.0143,
      41.8576,
      21.7899,
      43.2733
    ]
  },
  "LS": {
    "bbox": [
      27.0114,
      -30.678,
      29.4557,
      -28.5706
    ]
  },
  "BN": {
    "bbox": [
      113.0179,
      4.0025,
      115.3636,
      6.5466
    ]
  },
  "MY": {
    "bbox": [
      98.7365,
      0.8538,
      119.47,
      8.3801
    ]
  },
  "LU": {
    "bbox": [
      5.7357,
      49.4479,
      6.5312,
      50.1828
    ]
  },
  "AI": {
    "bbox": [
      -63.6392,
      18.0615,
      -62.7125,
      18.7951
    ]
  },
  "AS": {
    "bbox": [
      -171.2951,
      -14.7608,
      -167.9323,
      -10.845
    ]
  },
  "CX": {
    "bbox": [
      105.3301,
      -10.7714,
      105.9158,
      -10.2115
    ]
  },
  "HM": {
    "bbox": [
      72.2462,
      -53.3947,
      74.2045,
      -52.7031
    ]
  },
  "VU": {
    "bbox": [
      166.3355,
      -20.4627,
      170.45,
      -12.8714
    ]
  },
  "TV": {
    "bbox": [
      -180,
      -10.9939,
      180,
      -5.437
    ]
  },
  "GL": {
    "bbox": [
      -74.125,
      59.5154,
      -10.0289,
      83.8752
    ]
  },
  "CK": {
    "bbox": [
      -166.1319,
      -22.16,
      -157.1089,
      -8.715
    ]
  },
  "KY": {
    "bbox": [
      -81.6314,
      19.0621,
      -79.5111,
      19.9574
    ]
  },
  "FK": {
    "bbox": [
      -61.7727,
      -53.1187,
      -57.3662,
      -50.7973
    ]
  },
  "PN": {
    "bbox": [
      -130.9747,
      -25.2802,
      -124.5518,
      -23.707
    ]
  },
  "UM": {
    "bbox": [
      -177.6506,
      -0.5821,
      166.8696,
      28.4801
    ]
  },
  "TK": {
    "bbox": [
      -172.7238,
      -9.6461,
      -170.9777,
      -8.3305
    ]
  },
  "TF": {
    "bbox": [
      39.4139,
      -50.2187,
      77.8495,
      -11.314
    ]
  },
  "TO": {
    "bbox": [
      -179.395,
      -24.1635,
      -173.5295,
      -15.3656
    ]
  },
  "TD": {
    "bbox": [
      13.4735,
      7.4411,
      24,
      23.4508
    ]
  },
  "BV": {
    "bbox": [
      2.9346,
      -54.654,
      3.7791,
      -54.187
    ]
  },
  "XC": {
    "bbox": [
      32.4872,
      35.003,
      34.8553,
      35.9133
    ]
  },
  "BA": {
    "bbox": [
      15.7287,
      42.5553,
      19.6237,
      45.2764
    ]
  },
  "NF": {
    "bbox": [
      167.6857,
      -29.3371,
      168.2261,
      -28.7937
    ]
  },
  "NO": {
    "bbox": [
      4.0875,
      57.759,
      31.7616,
      71.3849
    ]
  },
  "SJ": {
    "bbox": [
      -9.6846,
      70.6261,
      34.6889,
      81.028
    ]
  },
  "CY": {
    "bbox": [
      32.0228,
      34.4384,
      34.3339,
      35.3991
    ]
  },
  "XD": {
    "bbox": [
      32.7545,
      34.5128,
      33.9445,
      35.1237
    ]
  },
  "PM": {
    "bbox": [
      -56.6975,
      46.5488,
      -55.9066,
      47.3416
    ]
  },
  "NC": {
    "bbox": [
      157.9848,
      -23.2218,
      172.3057,
      -17.6869
    ]
  },
  "WF": {
    "bbox": [
      -178.3874,
      -14.5631,
      -175.919,
      -12.9828
    ]
  },
  "PF": {
    "bbox": [
      -154.9361,
      -28.099,
      -134.2448,
      -7.6592
    ]
  },
  "XS": {
    "bbox": [
      42.7087,
      8,
      49.0801,
      11.7161
    ]
  },
  "MA": {
    "bbox": [
      -17.2448,
      21.3335,
      -0.9984,
      36.0021
    ]
  },
  "PR": {
    "bbox": [
      -68.1109,
      17.7307,
      -65.1101,
      18.6664
    ]
  },
  "EH": {
    "bbox": [
      -17.319,
      20.6673,
      -8.6663,
      27.6706
    ]
  },
  "NL": {
    "bbox": [
      3.0802,
      50.7504,
      7.2275,
      53.7444
    ]
  },
  "IT:LMP": {
    "bbox": [
      12.072,
      35.289,
      13.1282,
      36.0775
    ]
  },
  "IT-82:1": {
    "bbox": [
      11.6731,
      36.4397,
      15.6896,
      39.0227
    ]
  },
  "RU:E": {
    "bbox": [
      21.3924,
      41.1851,
      69.9572,
      82.0586
    ]
  },
  "GB-WLS": {
    "bbox": [
      -5.8077,
      51.229,
      -2.6499,
      53.635
    ]
  },
  "GB-SCT": {
    "bbox": [
      -14.0155,
      54.434,
      -0.3209,
      61.061
    ]
  },
  "GB-ENG": {
    "bbox": [
      -6.7047,
      49.674,
      2.0919,
      55.917
    ]
  },
  "BR:0": {
    "bbox": [
      -73.9831,
      -33.8694,
      -28.629,
      5.2696
    ]
  },
  "FR-20R": {
    "bbox": [
      8.2649,
      41.2611,
      9.8282,
      43.2277
    ]
  },
  "RU:A": {
    "bbox": [
      -180,
      41.2153,
      180,
      81.4742
    ]
  },
  "AU:0": {
    "bbox": [
      112.6998,
      -39.1907,
      168.2261,
      -9.088
    ]
  },
  "RU-KGD": {
    "bbox": [
      19.4042,
      54.3182,
      22.8867,
      55.3842
    ]
  },
  "EC:0": {
    "bbox": [
      -81.3443,
      -5.0159,
      -75.1925,
      1.4696
    ]
  },
  "CO:0": {
    "bbox": [
      -81.8157,
      -4.2294,
      -66.8511,
      12.6654
    ]
  },
  "CN-XZ": {
    "bbox": [
      78.3923,
      27.212,
      99.1155,
      36.4841
    ]
  },
  "SH-HL": {
    "bbox": [
      -5.9973,
      -16.23,
      -5.4234,
      -15.704
    ]
  },
  "SH-AC": {
    "bbox": [
      -14.6227,
      -8.193,
      -14.093,
      -7.69
    ]
  },
  "GB-NIR": {
    "bbox": [
      -8.1775,
      53.8702,
      -5.0778,
      55.4436
    ]
  },
  "US-HI": {
    "bbox": [
      -178.6016,
      18.7092,
      -154.5943,
      28.6571
    ]
  },
  "CL:0": {
    "bbox": [
      -80.3376,
      -56.725,
      -66.0753,
      -17.4984
    ]
  },
  "TR:A": {
    "bbox": [
      25.8625,
      35.8059,
      44.8177,
      42.297
    ]
  },
  "AZ-NX": {
    "bbox": [
      44.7634,
      38.8445,
      46.1497,
      39.794
    ]
  },
  "GR:0": {
    "bbox": [
      19.9892,
      35.7414,
      26.6356,
      41.7489
    ]
  },
  "AO:0": {
    "bbox": [
      11.461,
      -18.0394,
      24.0876,
      -5.8264
    ]
  },
  "TZ:0": {
    "bbox": [
      29.327,
      -11.7613,
      40.6584,
      -0.9855
    ]
  },
  "TR:E": {
    "bbox": [
      25.5656,
      35.923,
      29.7294,
      42.1048
    ]
  },
  "CN:0": {
    "bbox": [
      73.4997,
      14.9011,
      134.7755,
      53.5608
    ]
  },
  "VE:0": {
    "bbox": [
      -73.353,
      0.6474,
      -59.7707,
      15.9158
    ]
  },
  "PT:0": {
    "bbox": [
      -9.8348,
      36.7125,
      -6.1892,
      42.1543
    ]
  },
  "BR-PE:1": {
    "bbox": [
      -32.6763,
      -4.0823,
      -32.1712,
      -3.6034
    ]
  },
  "IN:0": {
    "bbox": [
      67.9544,
      7.8722,
      97.3956,
      35.6399
    ]
  },
  "YE:0": {
    "bbox": [
      41.6083,
      12.3649,
      53.1888,
      19
    ]
  },
  "PK:0": {
    "bbox": [
      60.8729,
      23.4342,
      77.0782,
      36.9882
    ]
  },
  "KR:0": {
    "bbox": [
      124.3727,
      33.7395,
      132.1468,
      38.6177
    ]
  },
  "PG:0": {
    "bbox": [
      140.8417,
      -11.8556,
      156.074,
      -2
    ]
  },
  "ES-IB": {
    "bbox": [
      0.8981,
      38.4369,
      4.5919,
      40.2951
    ]
  },
  "ES-CN": {
    "bbox": [
      -18.3937,
      27.4335,
      -13.1013,
      29.9118
    ]
  },
  "XJ": {
    "bbox": [
      72.5088,
      32.2764,
      79.4608,
      37.0841
    ]
  },
  "AZ:0": {
    "bbox": [
      44.764,
      38.393,
      51.1766,
      41.9647
    ]
  },
  "IT:0": {
    "bbox": [
      6.6273,
      37.7126,
      18.7845,
      47.0921
    ]
  },
  "JP:0": {
    "bbox": [
      128.1083,
      26.8389,
      145.916,
      45.7112
    ]
  },
  "CA-PE": {
    "bbox": [
      -64.5519,
      45.8495,
      -61.3994,
      47.6025
    ]
  },
  "AO-CAB": {
    "bbox": [
      11.8477,
      -5.8896,
      13.1107,
      -4.3458
    ]
  },
  "MU:0": {
    "bbox": [
      56.3816,
      -20.7286,
      59.927,
      -10.1352
    ]
  },
  "NZ:0": {
    "bbox": [
      -179.0592,
      -52.8214,
      179.3644,
      -29.0303
    ]
  },
  "GR-F": {
    "bbox": [
      19.1128,
      35.7414,
      23.4293,
      40.0606
    ]
  },
  "US-AK": {
    "bbox": [
      -180,
      51.007,
      180,
      71.589
    ]
  },
  "EA": {
    "bbox": [
      -5.4219,
      35.171,
      -2.4187,
      35.9985
    ]
  },
  "ES:0": {
    "bbox": [
      -9.5755,
      35.213,
      3.6051,
      43.9933
    ]
  },
  "FR:0": {
    "bbox": [
      -5.4518,
      42.3328,
      8.2328,
      51.3056
    ]
  },
  "CA:0": {
    "bbox": [
      -141.0027,
      41.6766,
      -52.3238,
      83.3362
    ]
  },
  "EG:0": {
    "bbox": [
      24.6499,
      21.9937,
      37.1154,
      31.8331
    ]
  },
  "ID-NU": {
    "bbox": [
      114.4127,
      -11.2086,
      125.5501,
      -6.7574
    ]
  },
  "EC-W": {
    "bbox": [
      -92.2072,
      -1.6122,
      -89.0382,
      1.8836
    ]
  },
  "PT-30": {
    "bbox": [
      -17.5045,
      29.8282,
      -15.6229,
      33.3272
    ]
  },
  "PT-20": {
    "bbox": [
      -31.5575,
      36.7255,
      -24.531,
      39.9267
    ]
  },
  "CL-VS:2": {
    "bbox": [
      -81.0783,
      -34.016,
      -78.5298,
      -33.406
    ]
  },
  "CL-VS:1": {
    "bbox": [
      -109.6796,
      -27.402,
      -105.1362,
      -26.269
    ]
  },
  "IN-SK": {
    "bbox": [
      88.012,
      27.0794,
      88.9214,
      28.1226
    ]
  },
  "IN-AN": {
    "bbox": [
      91.9933,
      6.5531,
      94.4784,
      13.8771
    ]
  },
  "IN-LD": {
    "bbox": [
      71.518,
      8.0648,
      73.9061,
      12.601
    ]
  },
  "MY:0": {
    "bbox": [
      98.7365,
      1.1955,
      115.3333,
      6.7261
    ]
  },
  "CN-HI": {
    "bbox": [
      108.3882,
      8.665,
      118.0444,
      20.3439
    ]
  },
  "AQ-AU": {
    "bbox": [
      72.2462,
      -55.3228,
      159.3403,
      -52.7031
    ]
  },
  "CO-SAP": {
    "bbox": [
      -82.1244,
      11.9616,
      -78.4257,
      16.0496
    ]
  },
  "VE-O": {
    "bbox": [
      -64.468,
      10.6903,
      -63.7177,
      11.2386
    ]
  },
  "BQ-BO": {
    "bbox": [
      -68.6255,
      11.825,
      -67.9916,
      12.512
    ]
  },
  "BQ:SSE": {
    "bbox": [
      -63.4688,
      17.2767,
      -62.7847,
      17.85
    ]
  },
  "AU-TAS": {
    "bbox": [
      143.5545,
      -44.0609,
      148.7656,
      -39.1893
    ]
  },
  "ID-JW": {
    "bbox": [
      104.6513,
      -9.0301,
      116.4842,
      -4.0388
    ]
  },
  "ID-KA": {
    "bbox": [
      108.1387,
      -5.4139,
      119.6681,
      4.4078
    ]
  },
  "ID-SL": {
    "bbox": [
      116.3438,
      -7.9722,
      127.754,
      5.764
    ]
  },
  "ID-SM": {
    "bbox": [
      94.7717,
      -6.455,
      109.7127,
      6.2744
    ]
  },
  "ID-ML": {
    "bbox": [
      123.9232,
      -8.5523,
      135.5899,
      3.4076
    ]
  },
  "KR-49": {
    "bbox": [
      125.7941,
      32.9105,
      127.2152,
      34.1398
    ]
  },
  "AQ-NO": {
    "bbox": [
      -90.7444,
      -68.9263,
      3.7791,
      -54.187
    ]
  },
  "BA:0": {
    "bbox": [
      15.7287,
      42.6026,
      19.466,
      45.2311
    ]
  },
  "BA-SRP": {
    "bbox": [
      16.2001,
      42.5553,
      19.6237,
      45.2764
    ]
  },
  "EH:0": {
    "bbox": [
      -17.319,
      20.6673,
      -8.6663,
      27.6706
    ]
  },
  "NZ-CIT": {
    "bbox": [
      -177.2447,
      -44.635,
      -175.5414,
      -43.3108
    ]
  },
  "GQ-C": {
    "bbox": [
      9.3024,
      0.8889,
      11.4114,
      2.3489
    ]
  },
  "GQ-I": {
    "bbox": [
      8.414,
      3.209,
      8.9381,
      3.7882
    ]
  },
  "EG:S": {
    "bbox": [
      32.5398,
      27.3883,
      34.9212,
      31.4668
    ]
  },
  "JP-13:1": {
    "bbox": [
      135.8537,
      20.2146,
      154.2055,
      27.9413
    ]
  },
  "SH-TA": {
    "bbox": [
      -12.957,
      -40.57,
      -9.6118,
      -36.862
    ]
  },
  "MU-RO": {
    "bbox": [
      63.0769,
      -20.0357,
      63.7158,
      -19.4521
    ]
  },
  "AE-AZ": {
    "bbox": [
      51.4161,
      22.6316,
      56.0174,
      25.3638
    ]
  },
  "AE-AJ": {
    "bbox": [
      55.2351,
      24.7395,
      56.1056,
      25.623
    ]
  },
  "AE-DU": {
    "bbox": [
      54.4565,
      24.6231,
      56.2036,
      25.5251
    ]
  },
  "AE-FU": {
    "bbox": [
      55.9698,
      24.9875,
      56.6014,
      25.6927
    ]
  },
  "AE-RK": {
    "bbox": [
      55.5987,
      24.8203,
      56.349,
      26.1517
    ]
  },
  "AE-SH": {
    "bbox": [
      53.9777,
      24.7573,
      56.6024,
      25.699
    ]
  },
  "AE-UQ": {
    "bbox": [
      55.3758,
      25.3122,
      55.8769,
      25.8531
    ]
  },
  "TZ-Z": {
    "bbox": [
      39.1817,
      -6.4781,
      39.5804,
      -5.7218
    ]
  },
  "PG:I": {
    "bbox": [
      142.1875,
      -7.0975,
      159.6935,
      -0.5574
    ]
  },
  "JP-47": {
    "bbox": [
      122.7142,
      23.8459,
      131.5542,
      28.0858
    ]
  },
  "MY:SA": {
    "bbox": [
      113.5902,
      3.9027,
      119.47,
      8.3801
    ]
  },
  "MY-13": {
    "bbox": [
      109.538,
      0.8538,
      115.678,
      5.1083
    ]
  },
  "GR:A": {
    "bbox": [
      24.041,
      35.258,
      29.6838,
      40.1124
    ]
  },
  "GR-M": {
    "bbox": [
      23.3726,
      34.7189,
      26.4526,
      35.7768
    ]
  },
  "ID-PP": {
    "bbox": [
      128.4449,
      -9.3861,
      141.0194,
      1.2874
    ]
  },
  "KN-K": {
    "bbox": [
      -63.0491,
      17.1042,
      -62.3948,
      17.6171
    ]
  },
  "YE-SU": {
    "bbox": [
      51.8585,
      11.9085,
      54.7389,
      12.913
    ]
  },
  "KN-N": {
    "bbox": [
      -62.8404,
      16.8926,
      -62.3742,
      17.3238
    ]
  },
  "PF:M": {
    "bbox": [
      -140.9253,
      -10.7544,
      -138.2107,
      -7.6592
    ]
  },
  "PF:0": {
    "bbox": [
      -154.935,
      -23.5756,
      -134.2448,
      -13.8907
    ]
  },
  "US-UM-79": {
    "bbox": [
      166.3829,
      19.0685,
      166.8696,
      19.5252
    ]
  },
  "KI:2": {
    "bbox": [
      -174.7434,
      -11.646,
      -149.9925,
      4.9
    ]
  },
  "KI-G": {
    "bbox": [
      169.3207,
      -2.8764,
      177.0491,
      3.5995
    ]
  },
  "IT-88": {
    "bbox": [
      7.8666,
      38.6557,
      10.0952,
      41.4337
    ]
  },
  "US-UM-71": {
    "bbox": [
      -177.6506,
      27.9911,
      -177.0875,
      28.4801
    ]
  },
  "AU:LDH": {
    "bbox": [
      158.8012,
      -31.9806,
      159.515,
      -31.2857
    ]
  },
  "US:0": {
    "bbox": [
      -125.0841,
      24.252,
      -66.8854,
      49.3845
    ]
  },
  "MA:0": {
    "bbox": [
      -13.4282,
      27.6273,
      -0.9984,
      36.0021
    ]
  },
  "PF:A": {
    "bbox": [
      -154.9361,
      -28.099,
      -143.2583,
      -21.5959
    ]
  },
  "SC:0": {
    "bbox": [
      55.0017,
      -5.0078,
      56.1534,
      -3.512
    ]
  },
  "SC:2": {
    "bbox": [
      45.9989,
      -10.4649,
      56.4979,
      -4.6716
    ]
  },
  "FR-F": {
    "bbox": [
      0.0528,
      46.3472,
      3.1286,
      48.941
    ]
  },
  "FR-B": {
    "bbox": [
      -1.791,
      42.7775,
      1.4481,
      45.7148
    ]
  },
  "FR-T": {
    "bbox": [
      -1.5627,
      45.089,
      1.2132,
      47.1759
    ]
  },
  "FR-G": {
    "bbox": [
      3.3836,
      47.5767,
      5.891,
      50.1693
    ]
  },
  "FR-U": {
    "bbox": [
      4.2301,
      42.982,
      7.7185,
      45.1266
    ]
  },
  "FR-C": {
    "bbox": [
      2.0629,
      44.6159,
      4.4905,
      46.8042
    ]
  },
  "FR-M": {
    "bbox": [
      4.8885,
      47.8137,
      7.6388,
      49.6169
    ]
  },
  "FR-J": {
    "bbox": [
      1.4462,
      48.1201,
      3.5592,
      49.2414
    ]
  },
  "FR-V": {
    "bbox": [
      3.6884,
      44.1152,
      7.1859,
      46.5199
    ]
  },
  "FR-N": {
    "bbox": [
      -0.3272,
      42.5732,
      3.452,
      45.0466
    ]
  },
  "FR-D": {
    "bbox": [
      2.8445,
      46.156,
      5.5189,
      48.4001
    ]
  },
  "FR-O": {
    "bbox": [
      1.5556,
      49.9689,
      4.2312,
      51.089
    ]
  },
  "FR-E": {
    "bbox": [
      -5.144,
      47.2778,
      -1.0157,
      49.1133
    ]
  },
  "FR-R": {
    "bbox": [
      -2.6282,
      46.2665,
      0.9166,
      48.5683
    ]
  },
  "FR-A": {
    "bbox": [
      6.8413,
      47.4203,
      8.2328,
      49.0778
    ]
  },
  "FR-P": {
    "bbox": [
      -1.9551,
      48.1794,
      0.9766,
      49.728
    ]
  },
  "FR-I": {
    "bbox": [
      5.252,
      46.261,
      7.1433,
      48.0241
    ]
  },
  "FR-S": {
    "bbox": [
      1.3798,
      48.8372,
      4.2557,
      50.3663
    ]
  },
  "FR-L": {
    "bbox": [
      0.6293,
      44.9205,
      2.6115,
      46.4553
    ]
  },
  "FR-K": {
    "bbox": [
      1.6887,
      42.3328,
      4.8455,
      44.9758
    ]
  },
  "FR-Q": {
    "bbox": [
      0.0658,
      48.6664,
      1.8029,
      50.0758
    ]
  },
  "GB-1WM": {
    "bbox": [
      -3.2355,
      51.8259,
      -1.1721,
      53.2262
    ]
  },
  "HU2": {
    "bbox": [
      16.1139,
      45.7371,
      19.0065,
      48.0225
    ]
  },
  "HU1": {
    "bbox": [
      18.6885,
      46.9441,
      20.1127,
      48.0587
    ]
  },
  "HU4": {
    "bbox": [
      18.7331,
      45.9048,
      22.8977,
      48.4258
    ]
  },
  "HU3": {
    "bbox": [
      18.9281,
      47.4204,
      22.1289,
      48.5853
    ]
  },
  "DE-MV": {
    "bbox": [
      10.5938,
      53.1102,
      14.4122,
      54.885
    ]
  },
  "GB-1EE": {
    "bbox": [
      -0.7458,
      51.4483,
      1.7689,
      52.9916
    ]
  },
  "AT-6": {
    "bbox": [
      13.5633,
      46.612,
      16.1718,
      47.8279
    ]
  },
  "FI-S": {
    "bbox": [
      22.6589,
      59.611,
      30.144,
      61.8643
    ]
  },
  "FI-W": {
    "bbox": [
      20.1636,
      59.4727,
      25.0363,
      64.179
    ]
  },
  "IT:PP": {
    "bbox": [
      11.6731,
      35.289,
      13.1282,
      37.039
    ]
  },
  "IT-82": {
    "bbox": [
      11.7747,
      36.4397,
      15.6896,
      39.0227
    ]
  },
  "IT-75": {
    "bbox": [
      14.9342,
      39.7896,
      18.5205,
      42.2265
    ]
  },
  "IT-77": {
    "bbox": [
      15.335,
      39.8958,
      16.867,
      41.1409
    ]
  },
  "IT-72": {
    "bbox": [
      13.7624,
      39.9905,
      15.8064,
      41.5081
    ]
  },
  "IT-62": {
    "bbox": [
      11.4492,
      40.7849,
      14.0276,
      42.8403
    ]
  },
  "IT-67": {
    "bbox": [
      13.9411,
      41.3641,
      15.1617,
      42.0703
    ]
  },
  "IT-52": {
    "bbox": [
      9.6868,
      42.2376,
      12.3714,
      44.4725
    ]
  },
  "IT-55": {
    "bbox": [
      11.892,
      42.3648,
      13.2642,
      43.6173
    ]
  },
  "IT-45": {
    "bbox": [
      9.1979,
      43.7319,
      12.7559,
      45.1395
    ]
  },
  "IT-34": {
    "bbox": [
      10.6231,
      44.7924,
      13.1022,
      46.6806
    ]
  },
  "IT-21": {
    "bbox": [
      6.6273,
      44.0597,
      9.2142,
      46.4642
    ]
  },
  "IT-25": {
    "bbox": [
      8.4979,
      44.6799,
      11.4276,
      46.6354
    ]
  },
  "IT-23": {
    "bbox": [
      6.8015,
      45.467,
      7.9395,
      45.9877
    ]
  },
  "IT-32": {
    "bbox": [
      10.3818,
      45.6729,
      12.478,
      47.0921
    ]
  },
  "NL1": {
    "bbox": [
      4.8184,
      52.6122,
      7.2275,
      53.5764
    ]
  },
  "NL2": {
    "bbox": [
      4.9939,
      51.7336,
      7.0728,
      52.8542
    ]
  },
  "NL3": {
    "bbox": [
      3.3079,
      51.2002,
      5.6273,
      53.2143
    ]
  },
  "NL4": {
    "bbox": [
      4.1901,
      50.7504,
      6.2268,
      51.8308
    ]
  },
  "RU-MOS": {
    "bbox": [
      35.1485,
      54.2557,
      40.2047,
      56.9585
    ]
  },
  "DE-SH": {
    "bbox": [
      7.5212,
      53.3598,
      11.6724,
      55.0992
    ]
  },
  "GB-1L": {
    "bbox": [
      -0.5104,
      51.2868,
      0.334,
      51.6919
    ]
  },
  "AT-7": {
    "bbox": [
      10.0978,
      46.6514,
      12.966,
      47.743
    ]
  },
  "AT-2": {
    "bbox": [
      12.6568,
      46.3723,
      15.0652,
      47.1313
    ]
  },
  "SE1": {
    "bbox": [
      11.9746,
      60.1886,
      24.1777,
      69.06
    ]
  },
  "SE2": {
    "bbox": [
      11.6911,
      58.399,
      20.0084,
      62.2675
    ]
  },
  "IT-57": {
    "bbox": [
      12.1855,
      42.6872,
      13.9163,
      43.9716
    ]
  },
  "BE-VLG": {
    "bbox": [
      2.5414,
      50.6874,
      5.9111,
      51.5051
    ]
  },
  "IT-65": {
    "bbox": [
      13.019,
      41.682,
      14.7839,
      42.8951
    ]
  },
  "BE-BRU": {
    "bbox": [
      4.2438,
      50.7637,
      4.4823,
      50.9139
    ]
  },
  "SE3": {
    "bbox": [
      10.5935,
      55.1371,
      17.5693,
      59.2636
    ]
  },
  "BR-ES": {
    "bbox": [
      -41.8798,
      -21.4366,
      -28.629,
      -17.892
    ]
  },
  "RO8": {
    "bbox": [
      22.336,
      45.2384,
      26.446,
      47.6084
    ]
  },
  "GB-1EM": {
    "bbox": [
      -2.0341,
      51.9773,
      0.358,
      53.6164
    ]
  },
  "GB-1SW": {
    "bbox": [
      -5.7471,
      49.9554,
      -1.4857,
      52.1126
    ]
  },
  "GB-3W": {
    "bbox": [
      -5.6703,
      51.3746,
      -2.6499,
      53.3608
    ]
  },
  "GB-1SE": {
    "bbox": [
      -1.9573,
      50.5747,
      1.4518,
      52.1963
    ]
  },
  "BR-RJ": {
    "bbox": [
      -44.8893,
      -23.6818,
      -40.6315,
      -20.7632
    ]
  },
  "MD1": {
    "bbox": [
      26.6164,
      45.4672,
      30.1637,
      48.4921
    ]
  },
  "BY-E": {
    "bbox": [
      26.0028,
      51.2627,
      32.7628,
      56.1722
    ]
  },
  "BY-W": {
    "bbox": [
      23.1783,
      51.4989,
      27.6161,
      54.9981
    ]
  },
  "BY-HM": {
    "bbox": [
      27.374,
      53.7938,
      28.0799,
      53.9718
    ]
  },
  "GB-1YH": {
    "bbox": [
      -2.5647,
      53.3015,
      0.1498,
      54.5621
    ]
  },
  "US-VT": {
    "bbox": [
      -73.4377,
      42.727,
      -71.4654,
      45.0167
    ]
  },
  "US-MA": {
    "bbox": [
      -73.5082,
      41.1889,
      -69.8601,
      42.8868
    ]
  },
  "US-NY": {
    "bbox": [
      -79.762,
      40.4766,
      -71.791,
      45.0159
    ]
  },
  "CA-QC": {
    "bbox": [
      -79.7629,
      44.9914,
      -57.1075,
      62.5825
    ]
  },
  "DE-RP": {
    "bbox": [
      6.1122,
      48.9661,
      8.5083,
      50.9423
    ]
  },
  "DE-TH": {
    "bbox": [
      9.877,
      50.2043,
      12.6539,
      51.6493
    ]
  },
  "DE-SL": {
    "bbox": [
      6.3558,
      49.112,
      7.4048,
      49.6394
    ]
  },
  "DE-BE": {
    "bbox": [
      13.0883,
      52.3382,
      13.7612,
      52.6755
    ]
  },
  "DE-SN": {
    "bbox": [
      11.8723,
      50.1713,
      15.0419,
      51.6851
    ]
  },
  "DE-BB": {
    "bbox": [
      11.2662,
      51.3591,
      14.7658,
      53.5591
    ]
  },
  "DE-ST": {
    "bbox": [
      10.5607,
      50.9379,
      13.1869,
      53.0417
    ]
  },
  "DE-BW": {
    "bbox": [
      7.5117,
      47.5325,
      10.4956,
      49.7913
    ]
  },
  "DE-HE": {
    "bbox": [
      7.7725,
      49.3953,
      10.2364,
      51.6578
    ]
  },
  "DE-HB": {
    "bbox": [
      8.4816,
      53.011,
      8.9907,
      53.6102
    ]
  },
  "DE-NW": {
    "bbox": [
      5.8663,
      50.3227,
      9.4617,
      52.5315
    ]
  },
  "DE-NI": {
    "bbox": [
      6.3459,
      51.2951,
      11.5981,
      54.1387
    ]
  },
  "DE-HH": {
    "bbox": [
      8.1045,
      53.3951,
      10.3253,
      54.0277
    ]
  },
  "US-ME": {
    "bbox": [
      -71.0842,
      42.9222,
      -66.8854,
      47.4598
    ]
  },
  "US-NH": {
    "bbox": [
      -72.5572,
      42.6972,
      -70.5614,
      45.3058
    ]
  },
  "CA-ON": {
    "bbox": [
      -95.156,
      41.6766,
      -74.3201,
      56.8614
    ]
  },
  "CA-NB": {
    "bbox": [
      -69.0535,
      44.2837,
      -63.3289,
      48.2207
    ]
  },
  "UA-65": {
    "bbox": [
      31.1591,
      45.7566,
      35.468,
      47.6002
    ]
  },
  "UA-07": {
    "bbox": [
      23.6054,
      50.2873,
      26.1073,
      51.9693
    ]
  },
  "UA-56": {
    "bbox": [
      25.0841,
      50.004,
      27.7346,
      51.9501
    ]
  },
  "UA-18": {
    "bbox": [
      27.1864,
      49.5836,
      29.7352,
      51.6811
    ]
  },
  "UA-K": {
    "bbox": [
      29.2675,
      49.1787,
      32.161,
      51.5532
    ]
  },
  "UA-74": {
    "bbox": [
      30.4821,
      50.3456,
      33.5007,
      52.3797
    ]
  },
  "UA-59": {
    "bbox": [
      32.9426,
      50.1102,
      35.6927,
      52.3667
    ]
  },
  "UA-63": {
    "bbox": [
      34.8563,
      48.5312,
      38.0935,
      50.4595
    ]
  },
  "RU-RYA": {
    "bbox": [
      38.666,
      53.3091,
      42.6921,
      55.3665
    ]
  },
  "UA-09": {
    "bbox": [
      37.8367,
      47.8251,
      40.2276,
      50.0884
    ]
  },
  "UA-14": {
    "bbox": [
      36.542,
      46.6877,
      39.0914,
      49.234
    ]
  },
  "UA-23": {
    "bbox": [
      34.1395,
      46.1465,
      37.2486,
      48.1449
    ]
  },
  "RU-LIP": {
    "bbox": [
      37.7217,
      51.8871,
      40.7648,
      53.5867
    ]
  },
  "RU-TAM": {
    "bbox": [
      39.9157,
      51.5881,
      43.2481,
      53.8226
    ]
  },
  "RU-VOR": {
    "bbox": [
      38.1378,
      49.558,
      42.9473,
      52.1031
    ]
  },
  "RU-PNZ": {
    "bbox": [
      42.0817,
      52.2913,
      46.9814,
      54.0308
    ]
  },
  "RU-ULY": {
    "bbox": [
      45.7967,
      52.5327,
      50.2434,
      54.8914
    ]
  },
  "RU-SAR": {
    "bbox": [
      42.504,
      49.8012,
      50.8326,
      52.8194
    ]
  },
  "RU-SAM": {
    "bbox": [
      47.9304,
      51.773,
      52.5683,
      54.6772
    ]
  },
  "RU-NIZ": {
    "bbox": [
      41.7765,
      54.4621,
      47.7718,
      58.0912
    ]
  },
  "RU-MO": {
    "bbox": [
      42.1643,
      53.6432,
      46.7296,
      55.1903
    ]
  },
  "RU-VLA": {
    "bbox": [
      38.2681,
      55.1014,
      42.9761,
      56.8127
    ]
  },
  "RU-KRS": {
    "bbox": [
      34.0803,
      50.9016,
      38.5193,
      52.4451
    ]
  },
  "RU-ORL": {
    "bbox": [
      34.792,
      51.935,
      38.0672,
      53.6525
    ]
  },
  "UA-46": {
    "bbox": [
      22.6408,
      48.7183,
      25.427,
      50.649
    ]
  },
  "RO6": {
    "bbox": [
      22.1808,
      47.3206,
      25.0564,
      48.12
    ]
  },
  "UA-26": {
    "bbox": [
      23.5471,
      47.7244,
      25.6531,
      49.5478
    ]
  },
  "UA-21": {
    "bbox": [
      22.1371,
      47.8969,
      24.6275,
      49.0973
    ]
  },
  "UA-61": {
    "bbox": [
      24.7196,
      48.5075,
      26.4433,
      50.2669
    ]
  },
  "UA-77": {
    "bbox": [
      24.9084,
      47.725,
      27.5343,
      48.6757
    ]
  },
  "UA-51": {
    "bbox": [
      28.2138,
      45.0532,
      31.305,
      48.2333
    ]
  },
  "UA-48": {
    "bbox": [
      30.2069,
      46.3448,
      33.1837,
      48.2322
    ]
  },
  "RU:CR": {
    "bbox": [
      32.2016,
      44.1846,
      36.6816,
      46.2296
    ]
  },
  "AT-8": {
    "bbox": [
      9.5307,
      46.8409,
      10.2372,
      47.5961
    ]
  },
  "AT-1": {
    "bbox": [
      15.9963,
      46.8306,
      17.1608,
      48.1187
    ]
  },
  "FR-H": {
    "bbox": [
      8.5347,
      41.3332,
      9.56,
      43.0277
    ]
  },
  "AT-3": {
    "bbox": [
      14.4526,
      47.4222,
      17.0688,
      49.0205
    ]
  },
  "RU-VGG": {
    "bbox": [
      41.1681,
      47.4437,
      47.4316,
      51.2476
    ]
  },
  "RU-ORE": {
    "bbox": [
      50.7682,
      50.4953,
      61.6898,
      54.3656
    ]
  },
  "RU-BA": {
    "bbox": [
      53.1575,
      51.5696,
      60.0018,
      56.5346
    ]
  },
  "RU-CHE": {
    "bbox": [
      57.1313,
      51.9909,
      63.352,
      56.3657
    ]
  },
  "RU-TA": {
    "bbox": [
      47.237,
      53.9742,
      54.2657,
      56.6782
    ]
  },
  "RU-SVE": {
    "bbox": [
      57.2266,
      56.0532,
      66.1849,
      61.9466
    ]
  },
  "ZA-WC": {
    "bbox": [
      17.5688,
      -35.0338,
      24.2224,
      -30.4303
    ]
  },
  "RU-CU": {
    "bbox": [
      45.9113,
      54.6274,
      48.4206,
      56.3285
    ]
  },
  "RU-TUL": {
    "bbox": [
      35.8986,
      52.9464,
      38.9515,
      54.8518
    ]
  },
  "RU-YAR": {
    "bbox": [
      37.3279,
      56.5343,
      41.1935,
      58.956
    ]
  },
  "RU-KLU": {
    "bbox": [
      33.4414,
      53.2769,
      37.2754,
      55.3513
    ]
  },
  "RU-SMO": {
    "bbox": [
      30.7516,
      53.4087,
      35.395,
      56.0671
    ]
  },
  "RU-BRY": {
    "bbox": [
      31.2419,
      51.8435,
      35.3251,
      54.034
    ]
  },
  "RU-BEL": {
    "bbox": [
      35.3258,
      49.7968,
      39.2808,
      51.4303
    ]
  },
  "RU-ROS": {
    "bbox": [
      38.2209,
      45.9517,
      44.3242,
      50.2144
    ]
  },
  "RU-IVA": {
    "bbox": [
      39.374,
      56.3523,
      43.3246,
      57.7405
    ]
  },
  "RU-KOS": {
    "bbox": [
      40.3901,
      57.2722,
      47.6395,
      59.6236
    ]
  },
  "AT-5": {
    "bbox": [
      12.0761,
      46.9439,
      13.9961,
      48.0415
    ]
  },
  "ZA-NC": {
    "bbox": [
      16.3335,
      -32.945,
      25.5493,
      -24.7638
    ]
  },
  "GB-1NE": {
    "bbox": [
      -2.6898,
      54.4511,
      -0.7884,
      55.8117
    ]
  },
  "GB-1NW": {
    "bbox": [
      -3.6406,
      52.9472,
      -1.9096,
      55.189
    ]
  },
  "ZA-EC": {
    "bbox": [
      22.7357,
      -34.4134,
      30.3719,
      -30.0018
    ]
  },
  "RU-NGR": {
    "bbox": [
      29.6187,
      56.9091,
      36.2289,
      59.4328
    ]
  },
  "BE-WAL": {
    "bbox": [
      2.842,
      49.497,
      6.4081,
      50.8121
    ]
  },
  "UA-05": {
    "bbox": [
      27.3729,
      48.0655,
      30.0208,
      49.8891
    ]
  },
  "UA-68": {
    "bbox": [
      26.1328,
      48.4511,
      27.8984,
      50.5947
    ]
  },
  "UA-71": {
    "bbox": [
      29.606,
      48.452,
      32.8962,
      50.2286
    ]
  },
  "UA-53": {
    "bbox": [
      32.0839,
      48.7234,
      35.4911,
      50.5535
    ]
  },
  "RO5": {
    "bbox": [
      20.7053,
      45.9019,
      23.8421,
      47.6001
    ]
  },
  "TH-C": {
    "bbox": [
      98.9846,
      13.219,
      101.7916,
      17.8172
    ]
  },
  "ZA-FS": {
    "bbox": [
      24.3466,
      -30.6941,
      29.7851,
      -26.6687
    ]
  },
  "IN-TN": {
    "bbox": [
      76.2329,
      8.0769,
      80.3593,
      13.5625
    ]
  },
  "UA-12": {
    "bbox": [
      32.9596,
      47.4566,
      36.9368,
      49.1939
    ]
  },
  "UA-35": {
    "bbox": [
      29.7493,
      47.7489,
      33.8943,
      49.2447
    ]
  },
  "RU-MOW": {
    "bbox": [
      36.8031,
      55.1422,
      37.9674,
      56.0212
    ]
  },
  "AT-4": {
    "bbox": [
      12.7492,
      47.4611,
      14.9922,
      48.7726
    ]
  },
  "PL-POM": {
    "bbox": [
      14.1229,
      52.3306,
      19.7616,
      54.8364
    ]
  },
  "IN-PY": {
    "bbox": [
      75.5266,
      10.8277,
      82.3137,
      16.7617
    ]
  },
  "EC2": {
    "bbox": [
      -80.4847,
      -4.7489,
      -77.5255,
      1.1979
    ]
  },
  "RU-STA": {
    "bbox": [
      40.846,
      43.6584,
      45.716,
      46.2365
    ]
  },
  "RU-KDA": {
    "bbox": [
      36.5305,
      43.2244,
      41.744,
      47.003
    ]
  },
  "RU-KL": {
    "bbox": [
      41.6343,
      44.7189,
      47.8268,
      48.2709
    ]
  },
  "EC3": {
    "bbox": [
      -79.4306,
      -5.0159,
      -75.1925,
      0.6624
    ]
  },
  "AT-9": {
    "bbox": [
      16.1818,
      48.1179,
      16.5775,
      48.3227
    ]
  },
  "EC1": {
    "bbox": [
      -81.0848,
      -3.8902,
      -78.4267,
      1.4696
    ]
  },
  "RU-DA": {
    "bbox": [
      45.1034,
      41.1851,
      48.809,
      44.9917
    ]
  },
  "RU-CE": {
    "bbox": [
      44.8323,
      42.4756,
      46.6627,
      44.0105
    ]
  },
  "RU-KC": {
    "bbox": [
      40.6752,
      43.1868,
      42.6814,
      44.4976
    ]
  },
  "RU-KB": {
    "bbox": [
      42.3973,
      42.8895,
      44.4754,
      44.0203
    ]
  },
  "RU-SE": {
    "bbox": [
      43.3985,
      42.5471,
      44.9604,
      43.8351
    ]
  },
  "RU-AST": {
    "bbox": [
      44.961,
      45.2623,
      49.8861,
      48.8636
    ]
  },
  "US-TX": {
    "bbox": [
      -106.6458,
      25.8371,
      -93.5078,
      36.5005
    ]
  },
  "RU-KIR": {
    "bbox": [
      46.2638,
      56.0608,
      53.93,
      61.0674
    ]
  },
  "RU-VLG": {
    "bbox": [
      34.7191,
      58.4773,
      47.1529,
      61.6142
    ]
  },
  "RU-ME": {
    "bbox": [
      45.6237,
      55.8295,
      50.203,
      57.3429
    ]
  },
  "RU-UD": {
    "bbox": [
      51.1242,
      55.8506,
      54.4361,
      58.5458
    ]
  },
  "RU-PER": {
    "bbox": [
      51.7724,
      56.1052,
      59.4825,
      61.6632
    ]
  },
  "RU-KO": {
    "bbox": [
      45.3993,
      59.1983,
      66.2517,
      68.4227
    ]
  },
  "US-IL": {
    "bbox": [
      -91.5131,
      36.9701,
      -87.0199,
      42.5084
    ]
  },
  "PL-LPL": {
    "bbox": [
      19.0831,
      49.002,
      24.1458,
      52.2878
    ]
  },
  "PL-MAS": {
    "bbox": [
      18.0746,
      50.8433,
      23.1284,
      53.4818
    ]
  },
  "PL-GPL": {
    "bbox": [
      14.5341,
      51.1038,
      19.105,
      53.6559
    ]
  },
  "RU-KGN": {
    "bbox": [
      61.9662,
      54.1879,
      68.7224,
      56.8423
    ]
  },
  "RU-TYU": {
    "bbox": [
      64.8272,
      55.1464,
      75.1993,
      59.9896
    ]
  },
  "RU-OMS": {
    "bbox": [
      70.3583,
      53.4354,
      76.3036,
      58.5757
    ]
  },
  "RU-NVS": {
    "bbox": [
      75.088,
      53.2914,
      85.116,
      57.2378
    ]
  },
  "RU-TOM": {
    "bbox": [
      75.0567,
      55.6058,
      89.379,
      61.0357
    ]
  },
  "RU-KHM": {
    "bbox": [
      59.2038,
      58.5799,
      85.9767,
      65.7177
    ]
  },
  "RU-ARK": {
    "bbox": [
      35.2696,
      60.6358,
      69.9572,
      82.0586
    ]
  },
  "RU-KEM": {
    "bbox": [
      84.4479,
      52.1627,
      89.4026,
      56.8351
    ]
  },
  "RU-ALT": {
    "bbox": [
      77.8891,
      50.64,
      87.1687,
      54.4531
    ]
  },
  "RU-AL": {
    "bbox": [
      83.9328,
      49.0709,
      89.8656,
      52.6603
    ]
  },
  "RU-TY": {
    "bbox": [
      88.792,
      49.7429,
      99.2737,
      53.7289
    ]
  },
  "RU-IRK": {
    "bbox": [
      95.6463,
      51.1299,
      119.1393,
      64.3215
    ]
  },
  "RU-BU": {
    "bbox": [
      98.6299,
      49.9698,
      116.9217,
      57.2499
    ]
  },
  "RU-ZAB": {
    "bbox": [
      107.7342,
      49.1542,
      122.1458,
      58.4374
    ]
  },
  "RU-AMU": {
    "bbox": [
      119.6554,
      48.8531,
      134.9209,
      57.0605
    ]
  },
  "RU-YEV": {
    "bbox": [
      130.5215,
      47.6565,
      134.9929,
      49.4941
    ]
  },
  "PH-00": {
    "bbox": [
      120.7917,
      14.3478,
      121.135,
      14.7853
    ]
  },
  "RU-KHA": {
    "bbox": [
      130.3867,
      46.6388,
      147.2168,
      62.5317
    ]
  },
  "RU-PRI": {
    "bbox": [
      130.3947,
      42.1227,
      139.3094,
      48.4652
    ]
  },
  "RU-MAG": {
    "bbox": [
      144.7286,
      58.6375,
      163.4957,
      66.3391
    ]
  },
  "RU-CHU": {
    "bbox": [
      -180,
      61.6078,
      180,
      71.8053
    ]
  },
  "RU-KAM": {
    "bbox": [
      155.2152,
      50.6856,
      174.5189,
      64.9375
    ]
  },
  "RU-SA": {
    "bbox": [
      105.5083,
      55.4877,
      163.106,
      77.3102
    ]
  },
  "CN-QH": {
    "bbox": [
      89.4022,
      31.6018,
      103.0694,
      39.2142
    ]
  },
  "CN-XJ": {
    "bbox": [
      73.4997,
      34.3341,
      96.3876,
      49.1781
    ]
  },
  "CN-GS": {
    "bbox": [
      92.3387,
      32.5987,
      108.7105,
      42.7946
    ]
  },
  "AR-F": {
    "bbox": [
      -69.635,
      -31.9982,
      -65.4231,
      -27.7098
    ]
  },
  "AR-D": {
    "bbox": [
      -67.4761,
      -36.0006,
      -64.8828,
      -31.8338
    ]
  },
  "AR-J": {
    "bbox": [
      -70.5697,
      -32.6266,
      -66.6613,
      -28.3888
    ]
  },
  "AR-M": {
    "bbox": [
      -70.5836,
      -37.5751,
      -66.4779,
      -31.9994
    ]
  },
  "AR-L": {
    "bbox": [
      -68.2968,
      -39.3298,
      -63.3827,
      -35.0023
    ]
  },
  "AR-S": {
    "bbox": [
      -62.8841,
      -34.3864,
      -58.8802,
      -27.9982
    ]
  },
  "AR-G": {
    "bbox": [
      -65.1884,
      -30.4805,
      -61.7118,
      -25.649
    ]
  },
  "AR-K": {
    "bbox": [
      -69.0952,
      -30.1196,
      -64.7807,
      -25.1686
    ]
  },
  "AR-R": {
    "bbox": [
      -71.9121,
      -41.9921,
      -62.7896,
      -37.5748
    ]
  },
  "AR-U": {
    "bbox": [
      -72.1878,
      -46,
      -63.3116,
      -41.992
    ]
  },
  "AR-Z": {
    "bbox": [
      -73.5605,
      -52.3976,
      -65.7182,
      -45.9997
    ]
  },
  "AR-V": {
    "bbox": [
      -68.6093,
      -55.0578,
      -63.7957,
      -52.6584
    ]
  },
  "AR-E": {
    "bbox": [
      -60.7716,
      -34.0392,
      -57.7974,
      -30.159
    ]
  },
  "AR-W": {
    "bbox": [
      -59.6723,
      -30.7297,
      -55.6202,
      -27.255
    ]
  },
  "AR-N": {
    "bbox": [
      -56.0586,
      -28.1642,
      -53.6375,
      -25.4943
    ]
  },
  "AR-H": {
    "bbox": [
      -63.4225,
      -28.0687,
      -58.3745,
      -24.0793
    ]
  },
  "AR-Y": {
    "bbox": [
      -67.2129,
      -24.6134,
      -64.1507,
      -21.7809
    ]
  },
  "AR-T": {
    "bbox": [
      -66.178,
      -28.0139,
      -64.4817,
      -26.0583
    ]
  },
  "TR-CAN": {
    "bbox": [
      29.9884,
      36.4358,
      38.7724,
      41.0971
    ]
  },
  "RU-PSK": {
    "bbox": [
      27.3174,
      55.5883,
      31.5179,
      59.0212
    ]
  },
  "DZ-C": {
    "bbox": [
      1.5264,
      35.4456,
      5.483,
      36.9236
    ]
  },
  "GB-IOS": {
    "bbox": [
      -6.7047,
      49.674,
      -5.9396,
      50.182
    ]
  },
  "CN-NM": {
    "bbox": [
      97.225,
      37.4067,
      125.3273,
      53.3341
    ]
  },
  "US-MO": {
    "bbox": [
      -95.7741,
      35.9957,
      -89.0988,
      40.6136
    ]
  },
  "US-KS": {
    "bbox": [
      -102.0518,
      36.9931,
      -94.5882,
      40.0032
    ]
  },
  "US-OK": {
    "bbox": [
      -103.0024,
      33.6192,
      -94.4312,
      37.0023
    ]
  },
  "US-AR": {
    "bbox": [
      -94.6179,
      33.0042,
      -89.6444,
      36.4996
    ]
  },
  "US-NE": {
    "bbox": [
      -104.0535,
      40,
      -95.3081,
      43.0013
    ]
  },
  "US-IA": {
    "bbox": [
      -96.6397,
      40.3756,
      -90.1401,
      43.5012
    ]
  },
  "US-SD": {
    "bbox": [
      -104.0578,
      42.4799,
      -96.4363,
      45.9455
    ]
  },
  "US-ND": {
    "bbox": [
      -104.0493,
      45.9351,
      -96.5544,
      49.0005
    ]
  },
  "US-KY": {
    "bbox": [
      -89.5715,
      36.4971,
      -81.9645,
      39.1478
    ]
  },
  "US-IN": {
    "bbox": [
      -88.0997,
      37.7717,
      -84.7846,
      41.7614
    ]
  },
  "US-TN": {
    "bbox": [
      -90.3103,
      34.9829,
      -81.6472,
      36.6781
    ]
  },
  "US-MS": {
    "bbox": [
      -91.655,
      30.1437,
      -88.0978,
      34.996
    ]
  },
  "US-AL": {
    "bbox": [
      -88.4731,
      30.1434,
      -84.8883,
      35.0081
    ]
  },
  "US-GA": {
    "bbox": [
      -85.6052,
      30.3557,
      -80.7514,
      35.0007
    ]
  },
  "US-CO": {
    "bbox": [
      -109.0602,
      36.9925,
      -102.0416,
      41.0034
    ]
  },
  "US-WY": {
    "bbox": [
      -111.0553,
      40.9948,
      -104.0524,
      45.0058
    ]
  },
  "US-UT": {
    "bbox": [
      -114.0529,
      36.9978,
      -109.0416,
      42.0017
    ]
  },
  "US-NM": {
    "bbox": [
      -109.0502,
      31.3322,
      -103.0022,
      37.0002
    ]
  },
  "US-AZ": {
    "bbox": [
      -114.8184,
      31.3322,
      -109.0451,
      37.0039
    ]
  },
  "US-FL": {
    "bbox": [
      -87.6349,
      24.3963,
      -79.9743,
      31.0008
    ]
  },
  "US-OH": {
    "bbox": [
      -84.8203,
      38.4031,
      -80.519,
      42.3232
    ]
  },
  "US-WV": {
    "bbox": [
      -82.6447,
      37.2014,
      -77.719,
      40.6388
    ]
  },
  "US-DC": {
    "bbox": [
      -77.1198,
      38.7916,
      -76.9094,
      38.996
    ]
  },
  "US-PA": {
    "bbox": [
      -80.5211,
      39.7198,
      -74.6897,
      42.5147
    ]
  },
  "US-DE": {
    "bbox": [
      -75.789,
      38.4512,
      -74.9849,
      39.8394
    ]
  },
  "US-MD": {
    "bbox": [
      -79.4873,
      37.8865,
      -74.9852,
      39.7229
    ]
  },
  "US-MT": {
    "bbox": [
      -116.0492,
      44.3579,
      -104.0396,
      49.0025
    ]
  },
  "US-ID": {
    "bbox": [
      -117.243,
      41.9888,
      -111.0436,
      49.0008
    ]
  },
  "US-WI": {
    "bbox": [
      -92.8893,
      42.492,
      -86.2495,
      47.3025
    ]
  },
  "US-MN": {
    "bbox": [
      -97.2393,
      43.4994,
      -89.4834,
      49.3845
    ]
  },
  "US-NV": {
    "bbox": [
      -120.0057,
      35.0019,
      -114.0403,
      42.0004
    ]
  },
  "US-CA": {
    "bbox": [
      -124.482,
      32.5295,
      -114.1308,
      42.0095
    ]
  },
  "US-OR": {
    "bbox": [
      -124.7035,
      41.9918,
      -116.4631,
      46.2928
    ]
  },
  "US-WA": {
    "bbox": [
      -124.8361,
      45.5437,
      -116.916,
      49.0024
    ]
  },
  "US-MI": {
    "bbox": [
      -90.4186,
      41.6961,
      -82.1228,
      48.3061
    ]
  },
  "US-CT": {
    "bbox": [
      -73.7278,
      40.951,
      -71.7872,
      42.0506
    ]
  },
  "TR-MED": {
    "bbox": [
      29.1917,
      35.8059,
      37.7517,
      38.6091
    ]
  },
  "TR-EAN": {
    "bbox": [
      37.2606,
      36.9629,
      44.8177,
      41.6003
    ]
  },
  "RU-LEN": {
    "bbox": [
      26.44,
      58.4173,
      35.7013,
      61.3293
    ]
  },
  "UZ-F": {
    "bbox": [
      70.3282,
      39.8955,
      73.2148,
      41.5487
    ]
  },
  "KG-2": {
    "bbox": [
      69.265,
      39.1727,
      74.9106,
      42.2208
    ]
  },
  "KG-1": {
    "bbox": [
      70.8652,
      41.8432,
      77.2257,
      43.2669
    ]
  },
  "KG-Y": {
    "bbox": [
      75.6415,
      41.1816,
      80.2296,
      42.9411
    ]
  },
  "IT-36": {
    "bbox": [
      12.3214,
      45.5809,
      13.9187,
      46.648
    ]
  },
  "BR-PA": {
    "bbox": [
      -58.897,
      -9.839,
      -45.9438,
      2.5909
    ]
  },
  "RU-KYA": {
    "bbox": [
      74.9869,
      51.7723,
      114.7396,
      81.4742
    ]
  },
  "RU-KK": {
    "bbox": [
      87.856,
      51.2841,
      91.9247,
      55.4373
    ]
  },
  "RU-YAN": {
    "bbox": [
      62.0004,
      62.1957,
      86.0073,
      73.7218
    ]
  },
  "GW:0": {
    "bbox": [
      -16.8975,
      10.8085,
      -13.6349,
      12.6862
    ]
  },
  "CD-2": {
    "bbox": [
      16.5106,
      -5,
      31.3057,
      5.392
    ]
  },
  "CD-5": {
    "bbox": [
      21.7508,
      -13.459,
      30.7962,
      -4.9999
    ]
  },
  "CD-1": {
    "bbox": [
      12.0391,
      -8.131,
      21.0053,
      -0.6954
    ]
  },
  "CD-4": {
    "bbox": [
      19.6735,
      -7.9951,
      26.2783,
      -1.6939
    ]
  },
  "UZ-QR": {
    "bbox": [
      55.9986,
      40.9936,
      62.4987,
      45.5907
    ]
  },
  "UZ-B": {
    "bbox": [
      60.0465,
      38.9522,
      67.5353,
      41.9966
    ]
  },
  "UZ-N": {
    "bbox": [
      61.6802,
      40.0068,
      66.7778,
      43.7354
    ]
  },
  "UZ-S": {
    "bbox": [
      64.3865,
      37.1816,
      68.4053,
      39.57
    ]
  },
  "UZ-T": {
    "bbox": [
      66.6434,
      39.53,
      71.2691,
      42.2951
    ]
  },
  "CN-JL": {
    "bbox": [
      121.6357,
      40.8618,
      131.3114,
      46.303
    ]
  },
  "CL:C": {
    "bbox": [
      -109.4549,
      -36.5436,
      -69.7702,
      -26.2862
    ]
  },
  "CN-HL": {
    "bbox": [
      121.1841,
      43.4232,
      134.7755,
      53.5608
    ]
  },
  "GT-H": {
    "bbox": [
      -92.1385,
      14.24,
      -89.1312,
      16.0739
    ]
  },
  "GT-P": {
    "bbox": [
      -92.2283,
      13.7401,
      -89.4985,
      15.4214
    ]
  },
  "GT-17": {
    "bbox": [
      -91.44,
      15.8474,
      -89.15,
      17.8166
    ]
  },
  "GT-18": {
    "bbox": [
      -89.6269,
      15.0688,
      -88.2134,
      16.0724
    ]
  },
  "KZ-K": {
    "bbox": [
      46.4932,
      41.2464,
      56.7441,
      51.7759
    ]
  },
  "KZ-C": {
    "bbox": [
      53.6305,
      45.1774,
      83.6197,
      51.709
    ]
  },
  "KZ-63": {
    "bbox": [
      81.1377,
      46.8629,
      87.3156,
      51.015
    ]
  },
  "KZ-AA": {
    "bbox": [
      73.722,
      42.2108,
      82.5877,
      47.3309
    ]
  },
  "KZ-S": {
    "bbox": [
      59.0306,
      40.5686,
      75.8241,
      47.8277
    ]
  },
  "KZ-N": {
    "bbox": [
      59.9941,
      48.1703,
      79.3471,
      55.4422
    ]
  },
  "HR-S": {
    "bbox": [
      16.9281,
      44.8497,
      19.4473,
      45.9961
    ]
  },
  "TM1": {
    "bbox": [
      56.4292,
      36.861,
      66.6904,
      42.7997
    ]
  },
  "TM2": {
    "bbox": [
      56.5886,
      35.1291,
      64.7575,
      40.2003
    ]
  },
  "TM-B": {
    "bbox": [
      52.2644,
      37.32,
      57.1472,
      42.3792
    ]
  },
  "TR-AEG": {
    "bbox": [
      26.1708,
      36.235,
      31.732,
      39.8789
    ]
  },
  "TR-SEA": {
    "bbox": [
      36.4621,
      36.6323,
      42.8845,
      38.7146
    ]
  },
  "PL-28": {
    "bbox": [
      19.1276,
      53.1391,
      22.8061,
      54.4533
    ]
  },
  "TR-MAR": {
    "bbox": [
      25.5656,
      39.072,
      31.0127,
      42.1048
    ]
  },
  "TR-BLC": {
    "bbox": [
      30.5648,
      39.8362,
      42.5921,
      42.297
    ]
  },
  "TR-34": {
    "bbox": [
      27.9708,
      40.7377,
      29.9588,
      41.671
    ]
  },
  "US-SC": {
    "bbox": [
      -83.354,
      32.0335,
      -78.5414,
      35.2155
    ]
  },
  "US-VA": {
    "bbox": [
      -83.6754,
      36.5408,
      -75.1664,
      39.466
    ]
  },
  "US-NC": {
    "bbox": [
      -84.3218,
      33.7529,
      -75.4001,
      36.5882
    ]
  },
  "HR-C": {
    "bbox": [
      14.9615,
      44.8797,
      17.499,
      46.555
    ]
  },
  "PL-SIL": {
    "bbox": [
      14.8174,
      49.394,
      19.9741,
      51.8048
    ]
  },
  "PL-20": {
    "bbox": [
      21.5928,
      52.2799,
      23.9463,
      54.4104
    ]
  },
  "US-LA": {
    "bbox": [
      -94.0432,
      28.8543,
      -88.7583,
      33.0196
    ]
  },
  "US-NJ": {
    "bbox": [
      -75.5634,
      38.7911,
      -73.8936,
      41.3573
    ]
  },
  "IR-KH": {
    "bbox": [
      55.405,
      30.5228,
      61.2833,
      38.285
    ]
  },
  "HR-18": {
    "bbox": [
      13.2105,
      44.4689,
      14.2586,
      45.5884
    ]
  },
  "HR-K": {
    "bbox": [
      13.9172,
      44.2603,
      16.141,
      45.6729
    ]
  },
  "HR-D": {
    "bbox": [
      14.2728,
      42.1766,
      18.5398,
      44.5444
    ]
  },
  "IR-C": {
    "bbox": [
      49.6406,
      26.445,
      59.7255,
      37.3261
    ]
  },
  "IR-KUR": {
    "bbox": [
      44.0319,
      32.0485,
      48.2873,
      39.7825
    ]
  },
  "IR-W": {
    "bbox": [
      46.8375,
      29.6674,
      51.8882,
      36.8152
    ]
  },
  "CL:N": {
    "bbox": [
      -71.7156,
      -32.2817,
      -66.9905,
      -17.4984
    ]
  },
  "IR-K": {
    "bbox": [
      48.5362,
      35.7317,
      56.3695,
      38.4603
    ]
  },
  "IR-AZ": {
    "bbox": [
      45.0935,
      35.578,
      49.4337,
      39.7091
    ]
  },
  "BR-RS": {
    "bbox": [
      -57.6489,
      -33.8689,
      -49.5306,
      -27.0825
    ]
  },
  "CL:S": {
    "bbox": [
      -74.8455,
      -44.0658,
      -70.8272,
      -36.0054
    ]
  },
  "RU-IN": {
    "bbox": [
      44.4784,
      42.6147,
      45.1954,
      43.6141
    ]
  },
  "RU-AD": {
    "bbox": [
      38.684,
      43.7601,
      40.7776,
      45.2171
    ]
  },
  "PG-C": {
    "bbox": [
      146.3049,
      -10.6538,
      149.9351,
      -7.7725
    ]
  },
  "IR-PG": {
    "bbox": [
      49.5801,
      25.1994,
      59.2358,
      30.295
    ]
  },
  "MN-E": {
    "bbox": [
      108.3856,
      44.7424,
      119.9322,
      50.2827
    ]
  },
  "MN-G": {
    "bbox": [
      93.0988,
      41.58,
      111.9678,
      47.7926
    ]
  },
  "MN-W": {
    "bbox": [
      87.7346,
      44.9994,
      99.2154,
      50.8843
    ]
  },
  "MN-N": {
    "bbox": [
      96.8755,
      47.2506,
      108.5714,
      52.1496
    ]
  },
  "MN-C": {
    "bbox": [
      98.1734,
      44.0489,
      109.0388,
      49.2049
    ]
  },
  "BW1": {
    "bbox": [
      22.9644,
      -25.8257,
      29.3739,
      -19
    ]
  },
  "BW2": {
    "bbox": [
      19.9986,
      -26.907,
      25.4466,
      -20.9954
    ]
  },
  "VE-V": {
    "bbox": [
      -73.353,
      8.3635,
      -70.67,
      11.8506
    ]
  },
  "VE-AN": {
    "bbox": [
      -72.4878,
      7.3613,
      -70.0345,
      10.0397
    ]
  },
  "VE-LL": {
    "bbox": [
      -72.42,
      6.0793,
      -62.6882,
      10.3741
    ]
  },
  "VE-DO": {
    "bbox": [
      -64.5652,
      7.7579,
      -59.8055,
      10.8243
    ]
  },
  "VE-CR": {
    "bbox": [
      -68.4287,
      9.2445,
      -65.4209,
      10.8764
    ]
  },
  "VE-CO": {
    "bbox": [
      -71.2813,
      9.3889,
      -68.1374,
      12.2555
    ]
  },
  "RU-NEN": {
    "bbox": [
      41.3126,
      65.821,
      65.6705,
      70.7304
    ]
  },
  "IE-C": {
    "bbox": [
      -10.3226,
      52.9682,
      -7.5842,
      54.4744
    ]
  },
  "IE-L": {
    "bbox": [
      -8.0837,
      52.1089,
      -5.9945,
      54.1139
    ]
  },
  "IE-M": {
    "bbox": [
      -10.6626,
      51.3889,
      -6.9499,
      53.1689
    ]
  },
  "IE-U": {
    "bbox": [
      -8.8347,
      53.7656,
      -6.5498,
      55.4353
    ]
  },
  "CN-GX": {
    "bbox": [
      104.4482,
      20.703,
      112.0564,
      26.3879
    ]
  },
  "CN-GZ": {
    "bbox": [
      103.6,
      24.6207,
      109.594,
      29.2244
    ]
  },
  "BR-SC": {
    "bbox": [
      -53.8373,
      -29.4249,
      -48.1108,
      -25.9557
    ]
  },
  "BR-PR": {
    "bbox": [
      -54.6199,
      -26.7209,
      -47.8652,
      -22.516
    ]
  },
  "BR-SP": {
    "bbox": [
      -53.109,
      -25.4833,
      -44.1614,
      -19.7823
    ]
  },
  "GB-AGY": {
    "bbox": [
      -4.6967,
      53.1262,
      -4.019,
      53.4358
    ]
  },
  "BR-RN": {
    "bbox": [
      -38.5821,
      -6.9827,
      -33.6135,
      -3.6543
    ]
  },
  "BR-PB": {
    "bbox": [
      -38.7656,
      -8.303,
      -34.5995,
      -6.0259
    ]
  },
  "IT-42": {
    "bbox": [
      7.4952,
      43.7757,
      10.0715,
      44.6764
    ]
  },
  "CL:P": {
    "bbox": [
      -75.7225,
      -56.5383,
      -66.416,
      -43.586
    ]
  },
  "BR-CE": {
    "bbox": [
      -41.4235,
      -7.858,
      -37.0787,
      -2.5753
    ]
  },
  "BR-PI": {
    "bbox": [
      -46.0271,
      -10.9281,
      -40.3705,
      -2.5763
    ]
  },
  "BR-PE": {
    "bbox": [
      -41.3583,
      -9.4831,
      -29.1448,
      1.1193
    ]
  },
  "BR-AL": {
    "bbox": [
      -38.2378,
      -10.6568,
      -34.9634,
      -8.8131
    ]
  },
  "BR-SE": {
    "bbox": [
      -38.245,
      -11.5685,
      -36.282,
      -9.515
    ]
  },
  "PG-H": {
    "bbox": [
      142.067,
      -7.1584,
      146.1362,
      -4.9408
    ]
  },
  "PG-S": {
    "bbox": [
      140.8417,
      -9.4693,
      146.6525,
      -4.9872
    ]
  },
  "PG-M": {
    "bbox": [
      141,
      -8.0417,
      148.3782,
      -2
    ]
  },
  "PG-MBA": {
    "bbox": [
      148.9667,
      -11.8556,
      156.074,
      -8.1009
    ]
  },
  "BR-MG": {
    "bbox": [
      -51.045,
      -22.9228,
      -39.8568,
      -14.2318
    ]
  },
  "ZW-1": {
    "bbox": [
      27.9767,
      -21.0474,
      32.9939,
      -15.6097
    ]
  },
  "ZM-ZB": {
    "bbox": [
      21.9994,
      -18.0762,
      28.926,
      -10.8878
    ]
  },
  "ZM-08": {
    "bbox": [
      26.7718,
      -13.9363,
      29.0847,
      -12.2217
    ]
  },
  "ZM-CZ": {
    "bbox": [
      25.3137,
      -15.9701,
      31.4397,
      -12.0294
    ]
  },
  "ZM-NP": {
    "bbox": [
      28.3711,
      -13.4338,
      33.7089,
      -8.2749
    ]
  },
  "ZM-03": {
    "bbox": [
      29.9795,
      -14.9974,
      33.7078,
      -10.3173
    ]
  },
  "BR-RO": {
    "bbox": [
      -66.8059,
      -13.6924,
      -59.7737,
      -7.9693
    ]
  },
  "BR-AC": {
    "bbox": [
      -73.9831,
      -11.1474,
      -66.6199,
      -7.1131
    ]
  },
  "BR-RR": {
    "bbox": [
      -64.8272,
      -1.5939,
      -58.886,
      5.2696
    ]
  },
  "BR-AP": {
    "bbox": [
      -54.8763,
      -1.2362,
      -49.3362,
      4.6731
    ]
  },
  "BR-AM": {
    "bbox": [
      -73.7984,
      -9.818,
      -56.097,
      2.2301
    ]
  },
  "BR-MA": {
    "bbox": [
      -48.7558,
      -10.2619,
      -41.6892,
      -0.7594
    ]
  },
  "BR-MT": {
    "bbox": [
      -61.633,
      -18.0416,
      -50.2076,
      -7.3483
    ]
  },
  "BR-MS": {
    "bbox": [
      -58.1697,
      -24.0686,
      -50.923,
      -17.1663
    ]
  },
  "BR-GO": {
    "bbox": [
      -53.2486,
      -19.4983,
      -45.9072,
      -12.3974
    ]
  },
  "BR-TO": {
    "bbox": [
      -50.7413,
      -13.467,
      -45.6993,
      -5.1695
    ]
  },
  "RU-SPE": {
    "bbox": [
      29.4258,
      59.6338,
      30.7595,
      60.2448
    ]
  },
  "JP:E": {
    "bbox": [
      134.2527,
      33.2333,
      137.3256,
      36.15
    ]
  },
  "ES-RI": {
    "bbox": [
      -3.1343,
      41.919,
      -1.6787,
      42.6443
    ]
  },
  "ES-CB": {
    "bbox": [
      -4.8517,
      42.758,
      -3.1497,
      43.5136
    ]
  },
  "ES-NC": {
    "bbox": [
      -2.4999,
      41.9099,
      -0.7233,
      43.3149
    ]
  },
  "ES-AS": {
    "bbox": [
      -7.1832,
      42.8825,
      -4.5106,
      43.6665
    ]
  },
  "ES-GA": {
    "bbox": [
      -9.3015,
      41.8074,
      -6.734,
      43.7904
    ]
  },
  "ES-CL": {
    "bbox": [
      -7.0771,
      40.0825,
      -1.7754,
      43.2382
    ]
  },
  "ES-PV": {
    "bbox": [
      -3.4509,
      42.4713,
      -1.7293,
      43.4569
    ]
  },
  "ES-VC": {
    "bbox": [
      -1.5289,
      37.8438,
      0.6903,
      40.7886
    ]
  },
  "ES-AN": {
    "bbox": [
      -7.5227,
      35.9376,
      -1.6298,
      38.7291
    ]
  },
  "ES-AR": {
    "bbox": [
      -2.1737,
      39.8468,
      0.7713,
      42.9245
    ]
  },
  "ES-MC": {
    "bbox": [
      -2.3444,
      37.3738,
      -0.6472,
      38.7551
    ]
  },
  "ES-EX": {
    "bbox": [
      -7.5417,
      37.941,
      -4.6476,
      40.4867
    ]
  },
  "ES-CM": {
    "bbox": [
      -5.4062,
      38.0224,
      -0.9158,
      41.3276
    ]
  },
  "ES-CT": {
    "bbox": [
      0.1594,
      40.523,
      3.3223,
      42.8615
    ]
  },
  "ES-MD": {
    "bbox": [
      -4.579,
      39.8846,
      -3.053,
      41.1657
    ]
  },
  "ZA-GP": {
    "bbox": [
      27.1563,
      -26.9238,
      29.0984,
      -25.1096
    ]
  },
  "ZA-KZN": {
    "bbox": [
      28.8735,
      -31.2176,
      33.1024,
      -26.8044
    ]
  },
  "ZA-NW": {
    "bbox": [
      22.629,
      -28.1132,
      28.2984,
      -24.6368
    ]
  },
  "ZA-LP": {
    "bbox": [
      26.4075,
      -25.4228,
      31.8844,
      -22.125
    ]
  },
  "ZA-MP": {
    "bbox": [
      28.2435,
      -27.5061,
      32.0337,
      -23.9812
    ]
  },
  "KP-3": {
    "bbox": [
      126.6608,
      39.2097,
      130.8861,
      43.009
    ]
  },
  "KP-1": {
    "bbox": [
      124.0924,
      38.4767,
      127.5094,
      41.8084
    ]
  },
  "KP-4": {
    "bbox": [
      124.3971,
      37.5833,
      127.0279,
      39.1727
    ]
  },
  "KP-2": {
    "bbox": [
      126.6696,
      38.1578,
      128.6538,
      39.4187
    ]
  },
  "JP:H": {
    "bbox": [
      128.1083,
      26.8389,
      132.2761,
      34.8917
    ]
  },
  "JP:D": {
    "bbox": [
      135.4493,
      34.2763,
      139.8999,
      38.8973
    ]
  },
  "PK-BA": {
    "bbox": [
      60.8729,
      24.7348,
      70.2619,
      32.0658
    ]
  },
  "PK-SD": {
    "bbox": [
      66.2862,
      23.4342,
      71.1258,
      28.4956
    ]
  },
  "PK-PB": {
    "bbox": [
      69.2618,
      27.7055,
      75.3815,
      34.0188
    ]
  },
  "PK-GB": {
    "bbox": [
      72.5088,
      34.5137,
      77.1204,
      37.0841
    ]
  },
  "PK-IS": {
    "bbox": [
      72.8176,
      33.4681,
      73.3749,
      33.8033
    ]
  },
  "BR-BA": {
    "bbox": [
      -46.5773,
      -18.3935,
      -37.1889,
      -8.5323
    ]
  },
  "IN-HP": {
    "bbox": [
      75.594,
      30.3772,
      79.0124,
      33.2557
    ]
  },
  "MT:M": {
    "bbox": [
      14.0469,
      35.5854,
      14.8228,
      36.1559
    ]
  },
  "GB-ORK": {
    "bbox": [
      -3.8218,
      58.6764,
      -1.9779,
      59.592
    ]
  },
  "RO2": {
    "bbox": [
      24.4215,
      43.6187,
      28.1974,
      45.8024
    ]
  },
  "NC:LIP": {
    "bbox": [
      165.8967,
      -21.861,
      168.3506,
      -20.0866
    ]
  },
  "YE-N": {
    "bbox": [
      41.6083,
      12.5166,
      47.0001,
      17.5658
    ]
  },
  "YE-S": {
    "bbox": [
      43.5232,
      12.3939,
      53.1888,
      19
    ]
  },
  "SK1": {
    "bbox": [
      16.8332,
      47.7312,
      19.0721,
      49.3197
    ]
  },
  "SK2": {
    "bbox": [
      18.3226,
      48.0536,
      20.4699,
      49.6138
    ]
  },
  "SK3": {
    "bbox": [
      19.8839,
      48.3326,
      22.5657,
      49.4609
    ]
  },
  "PY-GC": {
    "bbox": [
      -62.6407,
      -25.372,
      -57.1513,
      -19.2876
    ]
  },
  "PY-NP": {
    "bbox": [
      -57.9948,
      -25.0193,
      -55.5045,
      -22.0743
    ]
  },
  "PY-PP": {
    "bbox": [
      -57.043,
      -27.6064,
      -54.258,
      -23.5236
    ]
  },
  "PY-SP": {
    "bbox": [
      -58.6638,
      -27.4842,
      -56.495,
      -24.8414
    ]
  },
  "CA-NS": {
    "bbox": [
      -66.6807,
      43.1882,
      -59.2887,
      47.7611
    ]
  },
  "CA-NU": {
    "bbox": [
      -120.6828,
      51.1607,
      -59.6137,
      83.3362
    ]
  },
  "CA-MB": {
    "bbox": [
      -102.0076,
      48.9989,
      -88.9865,
      59.9995
    ]
  },
  "CA-BC": {
    "bbox": [
      -139.0613,
      48.2246,
      -114.0541,
      60.0021
    ]
  },
  "CA-SK": {
    "bbox": [
      -110.0064,
      48.9988,
      -101.3619,
      60
    ]
  },
  "CA-AB": {
    "bbox": [
      -120.0014,
      48.9967,
      -110.0048,
      60.0005
    ]
  },
  "CA-NL": {
    "bbox": [
      -67.8217,
      46.4102,
      -52.3238,
      60.477
    ]
  },
  "CA-NT": {
    "bbox": [
      -136.588,
      59.9983,
      -102.0006,
      79.13
    ]
  },
  "CA-YT": {
    "bbox": [
      -141.0027,
      59.9985,
      -123.8103,
      69.8459
    ]
  },
  "US-RI": {
    "bbox": [
      -71.9074,
      41.0958,
      -71.0886,
      42.0189
    ]
  },
  "BO-2": {
    "bbox": [
      -67.0055,
      -22.8828,
      -62.1933,
      -15.6735
    ]
  },
  "RU-KR": {
    "bbox": [
      29.3062,
      60.6805,
      37.9466,
      66.6673
    ]
  },
  "RU-SAK": {
    "bbox": [
      140.9221,
      43.1391,
      156.8029,
      54.626
    ]
  },
  "BO-1": {
    "bbox": [
      -69.645,
      -22.8983,
      -64.7146,
      -11.8478
    ]
  },
  "CO-AN": {
    "bbox": [
      -77.1271,
      1.5555,
      -71.9433,
      10.8676
    ]
  },
  "NO-W": {
    "bbox": [
      4.0875,
      58.0279,
      9.3648,
      63.7682
    ]
  },
  "BO-3": {
    "bbox": [
      -69.5718,
      -20.4733,
      -57.453,
      -9.6689
    ]
  },
  "NO-E": {
    "bbox": [
      7.0963,
      58.6033,
      12.8709,
      62.6969
    ]
  },
  "NO-50": {
    "bbox": [
      7.6481,
      62.2557,
      14.326,
      65.4702
    ]
  },
  "CN-HA": {
    "bbox": [
      110.3551,
      31.3845,
      116.6456,
      36.3668
    ]
  },
  "NO-N": {
    "bbox": [
      10.5781,
      64.9395,
      31.7615,
      71.3849
    ]
  },
  "BR-DF": {
    "bbox": [
      -48.2858,
      -16.0506,
      -47.3084,
      -15.5002
    ]
  },
  "AO-S": {
    "bbox": [
      11.461,
      -17.4388,
      17.4192,
      -13.3322
    ]
  },
  "AO-N": {
    "bbox": [
      12.0721,
      -11.7367,
      18.8388,
      -5.8264
    ]
  },
  "CZ1": {
    "bbox": [
      12.0906,
      48.5518,
      16.8674,
      51.0557
    ]
  },
  "CZ2": {
    "bbox": [
      15.5424,
      48.6165,
      18.4156,
      50.4494
    ]
  },
  "CZ-63": {
    "bbox": [
      14.8882,
      48.9376,
      16.4183,
      49.8612
    ]
  },
  "CZ-80": {
    "bbox": [
      17.1465,
      49.3926,
      18.8593,
      50.328
    ]
  },
  "IR-11": {
    "bbox": [
      58.7971,
      24.8353,
      63.3333,
      31.4865
    ]
  },
  "CN-ZJ": {
    "bbox": [
      118.0224,
      26.8591,
      123.3936,
      31.1826
    ]
  },
  "CN-FJ": {
    "bbox": [
      115.8473,
      23.1995,
      121.0337,
      28.3205
    ]
  },
  "GR:NOR": {
    "bbox": [
      19.9892,
      38.9237,
      26.6356,
      41.7489
    ]
  },
  "AO-E": {
    "bbox": [
      16.4607,
      -18.0394,
      24.0876,
      -6.9167
    ]
  },
  "GR:CNT": {
    "bbox": [
      20.6969,
      36.6897,
      24.786,
      39.2732
    ]
  },
  "CN-GD": {
    "bbox": [
      109.4495,
      20.1198,
      117.5802,
      25.5195
    ]
  },
  "CN-BJ": {
    "bbox": [
      115.4172,
      39.1707,
      123.9267,
      48.0117
    ]
  },
  "CN-LN": {
    "bbox": [
      118.8399,
      38.3719,
      125.7852,
      43.4889
    ]
  },
  "CN-HE": {
    "bbox": [
      113.4565,
      36.0484,
      119.9529,
      42.6176
    ]
  },
  "CN-TJ": {
    "bbox": [
      113.73,
      36.5663,
      118.0587,
      40.252
    ]
  },
  "CN-SD": {
    "bbox": [
      114.8169,
      34.3786,
      122.9568,
      38.6014
    ]
  },
  "CN-AH": {
    "bbox": [
      114.8762,
      29.3952,
      119.6453,
      34.6526
    ]
  },
  "CN-JS": {
    "bbox": [
      116.3552,
      30.7603,
      122.3867,
      35.1667
    ]
  },
  "CN-SH": {
    "bbox": [
      118.6002,
      30.6693,
      123.3342,
      31.881
    ]
  },
  "CN-SC": {
    "bbox": [
      97.3474,
      26.0482,
      108.5427,
      34.3147
    ]
  },
  "CN-CQ": {
    "bbox": [
      105.2868,
      28.1617,
      110.1944,
      32.2037
    ]
  },
  "CN-HN": {
    "bbox": [
      108.7861,
      24.6402,
      114.256,
      30.1284
    ]
  },
  "CN-YN": {
    "bbox": [
      97.5275,
      21.1431,
      106.1968,
      29.2257
    ]
  },
  "CN-SN": {
    "bbox": [
      105.4873,
      31.7067,
      111.2425,
      39.5849
    ]
  },
  "CN-NX": {
    "bbox": [
      104.2842,
      35.2388,
      107.6525,
      39.3818
    ]
  },
  "CN-SX": {
    "bbox": [
      110.2195,
      34.5841,
      114.5655,
      40.745
    ]
  },
  "CN-HB": {
    "bbox": [
      108.3626,
      29.0329,
      116.1322,
      33.2728
    ]
  },
  "CN-JX": {
    "bbox": [
      113.5749,
      24.4888,
      118.4822,
      30.08
    ]
  },
  "FI-L": {
    "bbox": [
      22.4342,
      60.9397,
      31.5867,
      64.037
    ]
  },
  "GR:PEL": {
    "bbox": [
      20.9256,
      36.1847,
      23.4546,
      38.3574
    ]
  },
  "SE-I": {
    "bbox": [
      17.5875,
      56.7012,
      19.7262,
      58.5978
    ]
  },
  "GR-K": {
    "bbox": [
      24.8709,
      37.4295,
      27.1648,
      40.1124
    ]
  },
  "BZ-C": {
    "bbox": [
      -89.2276,
      15.8857,
      -87.2765,
      18.4959
    ]
  },
  "BZ-I": {
    "bbox": [
      -89.1943,
      16.3989,
      -88.2867,
      18.2452
    ]
  },
  "BF-E": {
    "bbox": [
      -0.9119,
      10.9105,
      2.409,
      13.5783
    ]
  },
  "ES-CE": {
    "bbox": [
      -5.3885,
      35.8258,
      -5.0191,
      35.9985
    ]
  },
  "ES-ML": {
    "bbox": [
      -2.9702,
      35.2656,
      -2.6051,
      35.5019
    ]
  },
  "BF-N": {
    "bbox": [
      -2.9525,
      12.4794,
      1.2847,
      15.084
    ]
  },
  "GA-J": {
    "bbox": [
      10.2854,
      -2.5116,
      14.529,
      2.3193
    ]
  },
  "GA-H": {
    "bbox": [
      9.597,
      -2.685,
      12.5169,
      0.2566
    ]
  },
  "GA-C": {
    "bbox": [
      8.5002,
      -4.1269,
      11.975,
      1.0699
    ]
  },
  "TZ-NE": {
    "bbox": [
      33.2011,
      -5.9535,
      38.4049,
      -1.0289
    ]
  },
  "KG-N": {
    "bbox": [
      73.7118,
      40.2798,
      77.905,
      42.4546
    ]
  },
  "DZ-A": {
    "bbox": [
      -3.7907,
      30.3557,
      5.3378,
      36.0426
    ]
  },
  "DZ-S": {
    "bbox": [
      -8.6689,
      18.9681,
      11.9973,
      34.8625
    ]
  },
  "DZ-NW": {
    "bbox": [
      -2.2185,
      33.9085,
      2.6708,
      36.5556
    ]
  },
  "DZ-NE": {
    "bbox": [
      4.7283,
      34.1543,
      8.6811,
      37.0899
    ]
  },
  "PT-08": {
    "bbox": [
      -8.9971,
      36.96,
      -7.3949,
      37.5291
    ]
  },
  "RS-VO": {
    "bbox": [
      18.815,
      44.6297,
      21.5601,
      46.1903
    ]
  },
  "BG2": {
    "bbox": [
      22.8635,
      41.2354,
      27.0596,
      43.0387
    ]
  },
  "CO-AM": {
    "bbox": [
      -77.1868,
      -4.2294,
      -66.849,
      4.051
    ]
  },
  "CO-O": {
    "bbox": [
      -74.9339,
      1.6013,
      -67.4034,
      7.1044
    ]
  },
  "CO-C": {
    "bbox": [
      -76.5099,
      6.9993,
      -71.113,
      12.4573
    ]
  },
  "DK-82": {
    "bbox": [
      8.0982,
      55.6689,
      11.663,
      56.8466
    ]
  },
  "DK-81": {
    "bbox": [
      8.2209,
      56.5504,
      11.2002,
      57.7522
    ]
  },
  "DK-83": {
    "bbox": [
      8.0744,
      54.7219,
      10.9557,
      55.9566
    ]
  },
  "DK-85": {
    "bbox": [
      10.8684,
      54.5591,
      12.5526,
      56.0106
    ]
  },
  "DK-84": {
    "bbox": [
      11.682,
      55.5363,
      12.8226,
      56.2031
    ]
  },
  "CO-P": {
    "bbox": [
      -81.6166,
      0.3609,
      -75.7072,
      8.6774
    ]
  },
  "SJ-2": {
    "bbox": [
      -9.6846,
      70.6261,
      -7.3127,
      71.3598
    ]
  },
  "NO-21": {
    "bbox": [
      9.4209,
      74.1354,
      34.6889,
      81.028
    ]
  },
  "MX-TLA": {
    "bbox": [
      -98.7084,
      19.1051,
      -97.6254,
      19.7289
    ]
  },
  "MX-CMX": {
    "bbox": [
      -99.3649,
      19.0487,
      -98.9403,
      19.5928
    ]
  },
  "MX-MOR": {
    "bbox": [
      -99.4944,
      18.3324,
      -98.6329,
      19.1317
    ]
  },
  "MX-MEX": {
    "bbox": [
      -100.6131,
      18.3669,
      -98.5969,
      20.2859
    ]
  },
  "MX-HID": {
    "bbox": [
      -99.8595,
      19.5978,
      -97.9849,
      21.3985
    ]
  },
  "MX-PUE": {
    "bbox": [
      -99.0705,
      17.8609,
      -96.7246,
      20.8396
    ]
  },
  "GB-2H": {
    "bbox": [
      -7.1144,
      55.2745,
      -3.024,
      58.6975
    ]
  },
  "TN3": {
    "bbox": [
      7.522,
      30.2291,
      11.342,
      35.7909
    ]
  },
  "TN2": {
    "bbox": [
      9.2474,
      32.2499,
      11.5999,
      35.2785
    ]
  },
  "TN1": {
    "bbox": [
      8.1537,
      35.0202,
      11.1676,
      37.561
    ]
  },
  "BG3": {
    "bbox": [
      26.5786,
      41.9044,
      28.6093,
      44.0083
    ]
  },
  "PH-PLW": {
    "bbox": [
      116.793,
      7.418,
      121.4717,
      12.6069
    ]
  },
  "JP:C": {
    "bbox": [
      138.397,
      29.5936,
      141.1249,
      37.1551
    ]
  },
  "PH-L": {
    "bbox": [
      119.6078,
      11.5154,
      124.5631,
      21.2573
    ]
  },
  "MA:MM": {
    "bbox": [
      -6.2437,
      34.5148,
      -2.0563,
      35.9225
    ]
  },
  "TZ-NW": {
    "bbox": [
      29.5947,
      -9.0761,
      34.2424,
      -0.9855
    ]
  },
  "TZ-SH": {
    "bbox": [
      32.0207,
      -11.7613,
      38.115,
      -6.8672
    ]
  },
  "TZ-C": {
    "bbox": [
      33.4873,
      -9.9235,
      38.5166,
      -3.8032
    ]
  },
  "TZ-IO": {
    "bbox": [
      36.869,
      -11.4194,
      40.4454,
      -4.111
    ]
  },
  "AR-Q": {
    "bbox": [
      -71.9666,
      -41.1006,
      -67.9963,
      -36.0523
    ]
  },
  "CI:EP": {
    "bbox": [
      -5.6696,
      5.2153,
      -2.4949,
      8.7879
    ]
  },
  "CI:NS": {
    "bbox": [
      -8.2438,
      7.2334,
      -2.5968,
      10.7402
    ]
  },
  "CI:LG": {
    "bbox": [
      -5.4572,
      5.0905,
      -2.7235,
      6.2515
    ]
  },
  "TZ-P": {
    "bbox": [
      39.5626,
      -5.4864,
      39.8762,
      -4.8644
    ]
  },
  "ID-BA": {
    "bbox": [
      114.4127,
      -9.0502,
      115.8324,
      -7.4628
    ]
  },
  "ID-NB": {
    "bbox": [
      115.57,
      -9.3098,
      119.4887,
      -7.512
    ]
  },
  "AR-B": {
    "bbox": [
      -63.3927,
      -41.0383,
      -56.6651,
      -33.2616
    ]
  },
  "NZ:NS": {
    "bbox": [
      173.4925,
      -41.8151,
      178.8363,
      -36.8939
    ]
  },
  "NZ:SW": {
    "bbox": [
      166.1386,
      -47.724,
      173.5988,
      -40.2982
    ]
  },
  "NZ:SE": {
    "bbox": [
      168.1164,
      -46.8394,
      174.6035,
      -40.4608
    ]
  },
  "MX-NLE": {
    "bbox": [
      -101.2068,
      23.1627,
      -98.4216,
      27.7991
    ]
  },
  "MX-COA": {
    "bbox": [
      -103.96,
      24.5427,
      -99.8429,
      29.88
    ]
  },
  "GF:C": {
    "bbox": [
      -53.5378,
      3.9061,
      -52.1625,
      5.5746
    ]
  },
  "GF:SL": {
    "bbox": [
      -54.6027,
      2.1109,
      -53.0585,
      5.7769
    ]
  },
  "MX-CHH": {
    "bbox": [
      -109.075,
      25.5587,
      -103.3067,
      31.7839
    ]
  },
  "MX-SON": {
    "bbox": [
      -115.053,
      26.297,
      -108.4243,
      32.4941
    ]
  },
  "AF-NE": {
    "bbox": [
      68.004,
      34.9025,
      74.8899,
      38.4911
    ]
  },
  "AF-S": {
    "bbox": [
      60.5834,
      29.3773,
      68.1128,
      34.3693
    ]
  },
  "AF-E": {
    "bbox": [
      66.2769,
      31.5934,
      71.6814,
      35.4819
    ]
  },
  "AF-NW": {
    "bbox": [
      65.1605,
      34.8726,
      68.5679,
      37.5413
    ]
  },
  "AF-W": {
    "bbox": [
      60.5176,
      32.8498,
      66.7283,
      37.251
    ]
  },
  "RS-00": {
    "bbox": [
      19.9753,
      44.2628,
      20.8538,
      45.0969
    ]
  },
  "CH-GL": {
    "bbox": [
      8.8712,
      46.7965,
      9.2526,
      47.174
    ]
  },
  "CH-LU": {
    "bbox": [
      7.8364,
      46.775,
      8.5141,
      47.2872
    ]
  },
  "CH-BE": {
    "bbox": [
      6.8615,
      46.3265,
      8.4552,
      47.3453
    ]
  },
  "CH-AG": {
    "bbox": [
      7.7135,
      47.1375,
      8.4551,
      47.6211
    ]
  },
  "CH-BL": {
    "bbox": [
      7.3253,
      47.3379,
      7.9618,
      47.5644
    ]
  },
  "CH-ZG": {
    "bbox": [
      8.3948,
      47.081,
      8.7012,
      47.2484
    ]
  },
  "CH-OW": {
    "bbox": [
      8.0422,
      46.7532,
      8.5069,
      46.9805
    ]
  },
  "CH-NW": {
    "bbox": [
      8.2181,
      46.7715,
      8.5749,
      47.02
    ]
  },
  "CH-GR": {
    "bbox": [
      8.6511,
      46.1692,
      10.4923,
      47.0651
    ]
  },
  "CH-AR": {
    "bbox": [
      9.1911,
      47.247,
      9.631,
      47.469
    ]
  },
  "CH-AI": {
    "bbox": [
      9.3097,
      47.234,
      9.6184,
      47.4437
    ]
  },
  "CH-VS": {
    "bbox": [
      6.7706,
      45.8583,
      8.4786,
      46.6541
    ]
  },
  "CH-SG": {
    "bbox": [
      8.7956,
      46.8729,
      9.6741,
      47.5472
    ]
  },
  "CH-TI": {
    "bbox": [
      8.382,
      45.818,
      9.1597,
      46.6325
    ]
  },
  "CH-SZ": {
    "bbox": [
      8.3887,
      46.8853,
      9.0047,
      47.2226
    ]
  },
  "CH-ZH": {
    "bbox": [
      8.3577,
      47.1594,
      8.9849,
      47.6945
    ]
  },
  "CH-TG": {
    "bbox": [
      8.668,
      47.3759,
      9.5028,
      47.6954
    ]
  },
  "CH-UR": {
    "bbox": [
      8.3974,
      46.5276,
      8.9578,
      46.9934
    ]
  },
  "CH-SH": {
    "bbox": [
      8.4046,
      47.5524,
      8.8762,
      47.8085
    ]
  },
  "CH-JU": {
    "bbox": [
      6.8408,
      47.1504,
      7.5583,
      47.5045
    ]
  },
  "CH-FR": {
    "bbox": [
      6.7423,
      46.4379,
      7.3803,
      47.0068
    ]
  },
  "MD-GA": {
    "bbox": [
      28.2906,
      45.4851,
      29.0018,
      46.4714
    ]
  },
  "CH-BS": {
    "bbox": [
      7.5547,
      47.5193,
      7.6938,
      47.6009
    ]
  },
  "CH-SO": {
    "bbox": [
      7.3404,
      47.0743,
      8.0314,
      47.5027
    ]
  },
  "CH-GE": {
    "bbox": [
      5.9559,
      46.1286,
      6.3103,
      46.3646
    ]
  },
  "CH-NE": {
    "bbox": [
      6.4327,
      46.8466,
      7.0877,
      47.1656
    ]
  },
  "CH-VD": {
    "bbox": [
      6.0639,
      46.1871,
      7.2492,
      46.9867
    ]
  },
  "ET-TI": {
    "bbox": [
      36.4464,
      12.2563,
      39.9917,
      14.8943
    ]
  },
  "ET-AF": {
    "bbox": [
      39.6509,
      8.8417,
      42.4042,
      14.5492
    ]
  },
  "ET-AM": {
    "bbox": [
      35.2617,
      8.7159,
      40.2133,
      13.7809
    ]
  },
  "ET-BE": {
    "bbox": [
      34.0858,
      8.9513,
      36.6988,
      11.9854
    ]
  },
  "ET:1": {
    "bbox": [
      41.729,
      9.1869,
      42.3407,
      9.7847
    ]
  },
  "ET-GA": {
    "bbox": [
      32.9976,
      6.9976,
      35.3931,
      8.7099
    ]
  },
  "ET-OR": {
    "bbox": [
      34.1455,
      3.5094,
      42.9808,
      10.3913
    ]
  },
  "ET-SN": {
    "bbox": [
      35.7366,
      4.4388,
      38.7169,
      8.4587
    ]
  },
  "ET-SO": {
    "bbox": [
      39.0916,
      3.3974,
      47.9824,
      11.0956
    ]
  },
  "ET-AA": {
    "bbox": [
      38.6399,
      8.8331,
      38.9081,
      9.0986
    ]
  },
  "RS:P": {
    "bbox": [
      20.7434,
      42.2314,
      23.0063,
      44.8225
    ]
  },
  "MA:SM": {
    "bbox": [
      -7.7524,
      29.4766,
      -0.9984,
      34.9361
    ]
  },
  "MA:SA": {
    "bbox": [
      -9.8906,
      30.2614,
      -8.5482,
      32.7219
    ]
  },
  "MA:HA": {
    "bbox": [
      -9.3241,
      30.8107,
      -3.788,
      33.4826
    ]
  },
  "MA:AA": {
    "bbox": [
      -13.1934,
      27.6294,
      -6.3537,
      31.1666
    ]
  },
  "SO1": {
    "bbox": [
      40.9892,
      -1.8032,
      49.8104,
      7.71
    ]
  },
  "SO-P": {
    "bbox": [
      47.5571,
      7.2871,
      51.6178,
      12.1889
    ]
  },
  "FI-N": {
    "bbox": [
      20.5486,
      63.4291,
      30.5536,
      70.0923
    ]
  },
  "BG1": {
    "bbox": [
      22.3571,
      42.7088,
      27.6956,
      44.2155
    ]
  },
  "BG0": {
    "bbox": [
      22.3598,
      42.0209,
      24.4834,
      43.1998
    ]
  },
  "GW:B": {
    "bbox": [
      -16.743,
      10.6514,
      -15.1844,
      11.6549
    ]
  },
  "RS:W": {
    "bbox": [
      19.1026,
      43.0068,
      20.4371,
      44.9417
    ]
  },
  "GB-2L": {
    "bbox": [
      -5.3979,
      54.6332,
      -1.7644,
      57.7267
    ]
  },
  "IT-78": {
    "bbox": [
      15.6299,
      37.9158,
      17.2064,
      40.1449
    ]
  },
  "JP:B": {
    "bbox": [
      139.1382,
      36.7443,
      142.3315,
      41.6061
    ]
  },
  "AO-L": {
    "bbox": [
      12.7898,
      -10.4562,
      14.9807,
      -7.6352
    ]
  },
  "AO-C": {
    "bbox": [
      12.316,
      -14.3082,
      19.2242,
      -9.6698
    ]
  },
  "VN-NEV": {
    "bbox": [
      104.3343,
      20.4646,
      108.2233,
      23.3927
    ]
  },
  "GR-L": {
    "bbox": [
      24.041,
      35.258,
      29.6838,
      38.0782
    ]
  },
  "CU-99": {
    "bbox": [
      -83.5662,
      21.2376,
      -81.1005,
      22.3477
    ]
  },
  "CU-W": {
    "bbox": [
      -85.168,
      21.4272,
      -80.408,
      23.4817
    ]
  },
  "CU-C": {
    "bbox": [
      -80.943,
      20.124,
      -76.7738,
      23.4376
    ]
  },
  "CU-E": {
    "bbox": [
      -78.2649,
      19.6275,
      -73.919,
      21.7018
    ]
  },
  "VN-MRD": {
    "bbox": [
      103.0522,
      8.1791,
      106.9934,
      11.0321
    ]
  },
  "PE-SC": {
    "bbox": [
      -76.3984,
      -18.3501,
      -69.4684,
      -12.9649
    ]
  },
  "VN-CHV": {
    "bbox": [
      107.2065,
      11.2152,
      108.9953,
      15.4175
    ]
  },
  "VN-SCC": {
    "bbox": [
      107.2109,
      7.6921,
      114.8573,
      16.334
    ]
  },
  "PE-MDD": {
    "bbox": [
      -72.4287,
      -13.3414,
      -68.652,
      -9.9069
    ]
  },
  "VN-NCC": {
    "bbox": [
      103.8746,
      15.9944,
      108.4806,
      20.6707
    ]
  },
  "PE-NS": {
    "bbox": [
      -79.4585,
      -7.7635,
      -77.1323,
      -2.9861
    ]
  },
  "VN-SEV": {
    "bbox": [
      105.8091,
      8.3457,
      108.4311,
      12.2983
    ]
  },
  "VN-RDD": {
    "bbox": [
      105.289,
      19.6931,
      107.9511,
      21.5738
    ]
  },
  "VN-NWV": {
    "bbox": [
      102.1439,
      20.3054,
      105.8571,
      22.8449
    ]
  },
  "PE-PUN": {
    "bbox": [
      -71.1181,
      -17.2953,
      -68.7955,
      -13.0041
    ]
  },
  "TH-NE": {
    "bbox": [
      100.8324,
      14.1204,
      105.6368,
      18.4486
    ]
  },
  "TH-E": {
    "bbox": [
      100.4534,
      11.3464,
      102.941,
      14.4617
    ]
  },
  "TH-N": {
    "bbox": [
      97.3438,
      17.1617,
      101.3572,
      20.4648
    ]
  },
  "TH-S": {
    "bbox": [
      97.4348,
      5.6129,
      102.256,
      11.0313
    ]
  },
  "TH-W": {
    "bbox": [
      97.9098,
      10.9536,
      100.4541,
      17.833
    ]
  },
  "PE-PA": {
    "bbox": [
      -77.826,
      -11.4484,
      -69.9414,
      -0.0393
    ]
  },
  "PE-SS": {
    "bbox": [
      -76.5192,
      -15.6301,
      -70.3451,
      -10.6534
    ]
  },
  "IN-DL": {
    "bbox": [
      76.8388,
      28.4046,
      77.3466,
      28.8834
    ]
  },
  "IN-UP": {
    "bbox": [
      77.0839,
      23.8706,
      84.6345,
      30.4064
    ]
  },
  "IN-HR": {
    "bbox": [
      74.4735,
      27.6526,
      77.6021,
      30.9288
    ]
  },
  "IN-PB": {
    "bbox": [
      73.8798,
      29.5429,
      76.9391,
      32.5112
    ]
  },
  "IN-CH": {
    "bbox": [
      76.705,
      30.665,
      76.849,
      30.795
    ]
  },
  "IN-RJ": {
    "bbox": [
      69.4844,
      23.0594,
      78.272,
      30.1983
    ]
  },
  "IN-JK": {
    "bbox": [
      73.75,
      32.2764,
      76.7803,
      34.7871
    ]
  },
  "PE-CC": {
    "bbox": [
      -77.8863,
      -13.3242,
      -75.5075,
      -10.2742
    ]
  },
  "PE-CS": {
    "bbox": [
      -77.3175,
      -11.1558,
      -74.132,
      -8.3143
    ]
  },
  "IN-GJ": {
    "bbox": [
      68.1856,
      20.1195,
      74.476,
      24.7119
    ]
  },
  "IN-MP": {
    "bbox": [
      74.0303,
      21.0708,
      82.8094,
      26.8691
    ]
  },
  "IN-MH": {
    "bbox": [
      72.6526,
      15.6064,
      80.8978,
      22.0303
    ]
  },
  "PE-NC": {
    "bbox": [
      -81.3282,
      -10.7873,
      -76.7257,
      -3.3923
    ]
  },
  "IN-BR": {
    "bbox": [
      83.3213,
      24.2857,
      88.2982,
      27.5216
    ]
  },
  "GB-ELS": {
    "bbox": [
      -13.6875,
      56.7779,
      -5.8104,
      59.1347
    ]
  },
  "IN-WB": {
    "bbox": [
      85.8201,
      21.5473,
      89.8725,
      27.2212
    ]
  },
  "IN-JH": {
    "bbox": [
      83.3281,
      21.97,
      87.9628,
      25.3489
    ]
  },
  "IN-CT": {
    "bbox": [
      80.2442,
      17.7822,
      84.396,
      24.1067
    ]
  },
  "IN-OR": {
    "bbox": [
      81.3886,
      17.7949,
      87.4858,
      22.5676
    ]
  },
  "GH:C": {
    "bbox": [
      -3.1105,
      4.7393,
      1.1996,
      6.6338
    ]
  },
  "GE-AJ": {
    "bbox": [
      41.2994,
      41.4306,
      42.6027,
      41.9119
    ]
  },
  "GE1": {
    "bbox": [
      41.2902,
      41.0551,
      46.7365,
      43.257
    ]
  },
  "IN-KL": {
    "bbox": [
      74.8641,
      8.2935,
      77.4124,
      12.7961
    ]
  },
  "IN-KA": {
    "bbox": [
      74.0544,
      11.5946,
      78.5881,
      18.4766
    ]
  },
  "IN-AP": {
    "bbox": [
      76.7611,
      12.6227,
      84.7647,
      19.1663
    ]
  },
  "IN-AS": {
    "bbox": [
      89.6982,
      24.136,
      96.0124,
      27.9712
    ]
  },
  "IN-TR": {
    "bbox": [
      91.1508,
      22.9376,
      92.3358,
      24.5309
    ]
  },
  "IN-AR": {
    "bbox": [
      91.5623,
      26.6509,
      97.3956,
      29.3824
    ]
  },
  "IN-ML": {
    "bbox": [
      89.8144,
      25.0306,
      92.8027,
      26.1182
    ]
  },
  "IN-MN": {
    "bbox": [
      92.9707,
      23.8336,
      94.7452,
      25.6921
    ]
  },
  "IN-NL": {
    "bbox": [
      93.3267,
      25.1987,
      95.2424,
      27.0358
    ]
  },
  "IN-MZ": {
    "bbox": [
      92.2602,
      21.9413,
      93.4374,
      24.5212
    ]
  },
  "LY-C": {
    "bbox": [
      18.4993,
      27.0077,
      25.3771,
      33.1411
    ]
  },
  "LY-S": {
    "bbox": [
      9.399,
      19.5,
      25.0039,
      29.9708
    ]
  },
  "LY-T": {
    "bbox": [
      9.3911,
      28.4847,
      19.3801,
      33.3546
    ]
  },
  "RO-SV": {
    "bbox": [
      24.9471,
      47.0773,
      26.7047,
      47.988
    ]
  },
  "NZ:NN": {
    "bbox": [
      172.3928,
      -39.3007,
      176.5053,
      -34.1935
    ]
  },
  "RU-TVE": {
    "bbox": [
      30.7284,
      55.632,
      38.3269,
      58.8631
    ]
  },
  "ML-N": {
    "bbox": [
      -6.5719,
      14.9441,
      4.2674,
      25.0011
    ]
  },
  "ML-S": {
    "bbox": [
      -12.2403,
      10.1478,
      -0.7448,
      15.8625
    ]
  },
  "RU-MUR": {
    "bbox": [
      28.4158,
      65.6918,
      42.5057,
      70.153
    ]
  },
  "MT:G": {
    "bbox": [
      13.936,
      35.8561,
      14.5494,
      36.2825
    ]
  },
  "BW3": {
    "bbox": [
      20.9989,
      -21.0032,
      25.9888,
      -17.7781
    ]
  },
  "RS:S": {
    "bbox": [
      19.916,
      42.8322,
      21.8225,
      44.4436
    ]
  },
  "GR-69": {
    "bbox": [
      23.9509,
      40.0381,
      24.4991,
      40.5304
    ]
  },
  "DE-BY": {
    "bbox": [
      8.9764,
      47.2701,
      13.8396,
      50.5647
    ]
  },
  "DK-040": {
    "bbox": [
      14.3334,
      54.7837,
      15.5531,
      55.5334
    ]
  },
  "ME:R": {
    "bbox": [
      18.4337,
      41.8463,
      19.3886,
      42.6293
    ]
  },
  "SS-E": {
    "bbox": [
      26.289,
      3.489,
      35.949,
      6.7977
    ]
  },
  "SS-B": {
    "bbox": [
      23.4478,
      5.6733,
      31.6905,
      10.439
    ]
  },
  "SS-G": {
    "bbox": [
      28.6982,
      5.7209,
      35.0222,
      12.2364
    ]
  },
  "GB-ZET": {
    "bbox": [
      -2.5179,
      59.308,
      -0.3209,
      61.061
    ]
  },
  "RO7": {
    "bbox": [
      25.6596,
      45.3712,
      28.2611,
      48.2655
    ]
  },
  "RO3": {
    "bbox": [
      22.0161,
      43.6819,
      24.8866,
      45.5909
    ]
  },
  "VE-GU": {
    "bbox": [
      -67.863,
      0.6474,
      -60.2405,
      8.4669
    ]
  },
  "VE-CI": {
    "bbox": [
      -70.9916,
      10.5769,
      -61.8028,
      15.745
    ]
  },
  "NA-CA": {
    "bbox": [
      22.5,
      -18.5023,
      25.2617,
      -17.47
    ]
  },
  "NA-C": {
    "bbox": [
      13.6327,
      -24.046,
      20.9991,
      -18.7475
    ]
  },
  "NA-S": {
    "bbox": [
      14.4517,
      -28.9694,
      20.0001,
      -23.1684
    ]
  },
  "NA-N": {
    "bbox": [
      11.7367,
      -21.1935,
      22.5001,
      -16.9635
    ]
  },
  "KR-1": {
    "bbox": [
      124.3727,
      36.8544,
      127.8481,
      38.2811
    ]
  },
  "KR-3": {
    "bbox": [
      127.5759,
      34.1697,
      132.1468,
      37.7534
    ]
  },
  "KR-42": {
    "bbox": [
      127.0959,
      37.0278,
      129.6244,
      38.6177
    ]
  },
  "AU-NSW": {
    "bbox": [
      140.9993,
      -37.528,
      159.339,
      -28.1415
    ]
  },
  "AU-NT": {
    "bbox": [
      129.0004,
      -25.9986,
      138.0274,
      -10.8525
    ]
  },
  "AU-QLD": {
    "bbox": [
      137.9946,
      -29.1793,
      153.6116,
      -9.088
    ]
  },
  "AU-SA": {
    "bbox": [
      129.0014,
      -38.1133,
      141.0028,
      -25.9964
    ]
  },
  "AU-WA": {
    "bbox": [
      112.8657,
      -35.2419,
      129.002,
      -13.5077
    ]
  },
  "AU-VIC": {
    "bbox": [
      140.9619,
      -39.1985,
      150.0333,
      -33.9808
    ]
  },
  "ME:M": {
    "bbox": [
      18.6484,
      42.4658,
      20.3529,
      43.5585
    ]
  },
  "ME:C": {
    "bbox": [
      18.4504,
      42.2434,
      19.6648,
      43.102
    ]
  },
  "BQ-SA": {
    "bbox": [
      -63.4688,
      17.414,
      -63.026,
      17.85
    ]
  },
  "BQ-SE": {
    "bbox": [
      -63.1986,
      17.2767,
      -62.7847,
      17.727
    ]
  },
  "KR-2": {
    "bbox": [
      125.2883,
      35.9783,
      128.6521,
      37.2583
    ]
  },
  "MX-MIC": {
    "bbox": [
      -103.739,
      17.9149,
      -100.063,
      20.3945
    ]
  },
  "MX-QUE": {
    "bbox": [
      -100.5965,
      20.015,
      -99.0431,
      21.67
    ]
  },
  "MX-GUA": {
    "bbox": [
      -102.0973,
      19.9128,
      -99.6713,
      21.8394
    ]
  },
  "MX-JAL": {
    "bbox": [
      -105.6954,
      18.9259,
      -101.5105,
      22.7502
    ]
  },
  "MX-COL": {
    "bbox": [
      -114.7598,
      18.3392,
      -103.4863,
      19.5125
    ]
  },
  "AU-ACT": {
    "bbox": [
      148.7628,
      -35.9205,
      149.3993,
      -35.1244
    ]
  },
  "KR-4": {
    "bbox": [
      124.8364,
      33.7395,
      128.1716,
      36.2782
    ]
  },
  "RO4": {
    "bbox": [
      20.262,
      44.5853,
      22.7128,
      46.1899
    ]
  },
  "RO1": {
    "bbox": [
      27.2727,
      43.7337,
      29.7684,
      45.4674
    ]
  },
  "AZ-N": {
    "bbox": [
      44.7634,
      38.8445,
      46.1497,
      39.7944
    ]
  },
  "ID-NT": {
    "bbox": [
      118.371,
      -11.2086,
      125.5501,
      -6.7574
    ]
  },
  "ID-MA": {
    "bbox": [
      124.9518,
      -8.5523,
      135.5899,
      -2.2664
    ]
  },
  "ID-MU": {
    "bbox": [
      123.9232,
      -2.7956,
      130.0686,
      3.4076
    ]
  },
  "MX-ZAC": {
    "bbox": [
      -104.3535,
      21.0419,
      -100.7423,
      25.1252
    ]
  },
  "MX-DUR": {
    "bbox": [
      -107.2101,
      22.3451,
      -102.4727,
      26.8448
    ]
  },
  "AR-A": {
    "bbox": [
      -68.5679,
      -26.4167,
      -62.3392,
      -21.9988
    ]
  },
  "MX-TAM": {
    "bbox": [
      -100.145,
      22.207,
      -97.1442,
      27.6791
    ]
  },
  "MX-VER": {
    "bbox": [
      -98.6815,
      17.137,
      -93.6079,
      22.4718
    ]
  },
  "MA:NA": {
    "bbox": [
      -9.0592,
      32.2966,
      -5.3152,
      35.0155
    ]
  },
  "MA:WS": {
    "bbox": [
      -17.2448,
      21.3335,
      -8.7302,
      27.6666
    ]
  },
  "MX-GRO": {
    "bbox": [
      -102.1844,
      16.3162,
      -98.0073,
      18.8878
    ]
  },
  "MX-SIN": {
    "bbox": [
      -109.4446,
      22.4671,
      -105.3922,
      27.0422
    ]
  },
  "BA-BRC": {
    "bbox": [
      18.5098,
      44.7203,
      19.0215,
      44.9673
    ]
  },
  "BA-BIH": {
    "bbox": [
      15.7287,
      42.6026,
      19.0499,
      45.2311
    ]
  },
  "MX-OAX": {
    "bbox": [
      -98.5527,
      15.6569,
      -93.8674,
      18.6697
    ]
  },
  "TD-1": {
    "bbox": [
      14.9986,
      15.309,
      24,
      23.4508
    ]
  },
  "TD-2": {
    "bbox": [
      13.4735,
      9.826,
      23.1107,
      16.8433
    ]
  },
  "MX-CHP": {
    "bbox": [
      -94.1392,
      14.5311,
      -90.3715,
      17.9853
    ]
  },
  "MX-TAB": {
    "bbox": [
      -94.13,
      17.2509,
      -90.9873,
      18.6504
    ]
  },
  "MX-CAM": {
    "bbox": [
      -92.469,
      17.8124,
      -89.1212,
      20.8483
    ]
  },
  "MX-BCN": {
    "bbox": [
      -118.3651,
      28,
      -112.7527,
      32.7187
    ]
  },
  "MX-BCS": {
    "bbox": [
      -115.7692,
      22.8716,
      -109.4132,
      28
    ]
  },
  "MX-AGU": {
    "bbox": [
      -102.8742,
      21.6223,
      -101.8353,
      22.4596
    ]
  },
  "MX-ROO": {
    "bbox": [
      -89.2966,
      17.894,
      -86.7107,
      21.6055
    ]
  },
  "MX-YUC": {
    "bbox": [
      -92.3082,
      19.5512,
      -87.5331,
      22.529
    ]
  },
  "CF-E": {
    "bbox": [
      18.8607,
      4.115,
      27.4665,
      11.0014
    ]
  },
  "BF-BV": {
    "bbox": [
      -5.5132,
      9.4105,
      -2.4414,
      13.7145
    ]
  },
  "BF-VD": {
    "bbox": [
      -2.9317,
      10.9624,
      -0.4113,
      12.9331
    ]
  },
  "CM1": {
    "bbox": [
      12.2438,
      7.0147,
      15.6891,
      13.0833
    ]
  },
  "CM-AD": {
    "bbox": [
      11.1826,
      5.9748,
      15.2336,
      8.1914
    ]
  },
  "CM4": {
    "bbox": [
      9.8316,
      1.6518,
      16.1911,
      6.2644
    ]
  },
  "CM3": {
    "bbox": [
      9.2052,
      2.1432,
      11.18,
      5.335
    ]
  },
  "CM2": {
    "bbox": [
      8.3822,
      3.7437,
      11.2104,
      7.1622
    ]
  },
  "GQ-AN": {
    "bbox": [
      5.6168,
      -1.4737,
      5.658,
      -1.4005
    ]
  },
  "AR-P": {
    "bbox": [
      -62.3425,
      -26.872,
      -57.5543,
      -22.4714
    ]
  },
  "PT-11": {
    "bbox": [
      -9.5005,
      38.6731,
      -8.7819,
      39.3177
    ]
  },
  "MZ3": {
    "bbox": [
      34.3782,
      -18.9015,
      40.8393,
      -10.4708
    ]
  },
  "MZ1": {
    "bbox": [
      31.3074,
      -26.8681,
      35.6033,
      -20.8851
    ]
  },
  "MZ2": {
    "bbox": [
      30.2122,
      -21.5852,
      36.1934,
      -13.9988
    ]
  },
  "MY:1": {
    "bbox": [
      99.6405,
      1.8395,
      102.7011,
      6.7261
    ]
  },
  "MY-01": {
    "bbox": [
      102.3475,
      1.1955,
      104.7512,
      2.8346
    ]
  },
  "CF-N": {
    "bbox": [
      14.4148,
      4.9359,
      20.1348,
      8.5739
    ]
  },
  "CF-S": {
    "bbox": [
      14.6743,
      2.2256,
      20.0046,
      6.5442
    ]
  },
  "IQ-K": {
    "bbox": [
      42.3483,
      34.546,
      46.3471,
      37.3807
    ]
  },
  "IQ-N": {
    "bbox": [
      39.81,
      33.2718,
      44.941,
      37.0607
    ]
  },
  "EG.SI": {
    "bbox": [
      32.5398,
      27.3883,
      34.9212,
      31.4668
    ]
  },
  "EG.UE": {
    "bbox": [
      31.0981,
      22,
      33.5662,
      26.8003
    ]
  },
  "EG-BA": {
    "bbox": [
      31.7881,
      21.9937,
      37.1154,
      29.1387
    ]
  },
  "EG-MT": {
    "bbox": [
      24.6499,
      27.738,
      30.3112,
      31.8331
    ]
  },
  "EG-WAD": {
    "bbox": [
      24.9969,
      22,
      32.7402,
      27.7489
    ]
  },
  "EG.LE": {
    "bbox": [
      27.3106,
      27.738,
      32.833,
      31.8004
    ]
  },
  "AR-C": {
    "bbox": [
      -58.5314,
      -34.7056,
      -58.3351,
      -34.5266
    ]
  },
  "TD-3": {
    "bbox": [
      13.9766,
      7.4411,
      22.9753,
      13.059
    ]
  },
  "MG-U": {
    "bbox": [
      43.2202,
      -25.6061,
      47.4172,
      -18.1651
    ]
  },
  "MG-F": {
    "bbox": [
      44.9771,
      -24.2993,
      48.5985,
      -19.8791
    ]
  },
  "MG-M": {
    "bbox": [
      43.9255,
      -19.3276,
      49.4477,
      -13.8739
    ]
  },
  "MG-A": {
    "bbox": [
      47.6477,
      -20.4702,
      50.0461,
      -14.8807
    ]
  },
  "MG-T": {
    "bbox": [
      45.4754,
      -20.2833,
      48.0455,
      -17.6901
    ]
  },
  "JP:F": {
    "bbox": [
      130.3979,
      33.5529,
      134.5154,
      36.5558
    ]
  },
  "NE-1": {
    "bbox": [
      4.2663,
      15.3195,
      15.9967,
      23.5172
    ]
  },
  "NE-S": {
    "bbox": [
      3.8697,
      12.8074,
      15.5594,
      18.6814
    ]
  },
  "NE-W": {
    "bbox": [
      0.169,
      11.6936,
      4.6016,
      15.6968
    ]
  },
  "CG-NV": {
    "bbox": [
      11.5167,
      -4.9162,
      14.3773,
      -1.8125
    ]
  },
  "CG-C": {
    "bbox": [
      13.8429,
      -2.0363,
      17.5256,
      1.3911
    ]
  },
  "CG-CM": {
    "bbox": [
      11.1477,
      -5.0428,
      12.7822,
      -3.5064
    ]
  },
  "CG-N": {
    "bbox": [
      13.1252,
      -0.7502,
      18.6436,
      3.7131
    ]
  },
  "CG-14": {
    "bbox": [
      14.1062,
      -3.0969,
      16.6362,
      -0.9322
    ]
  },
  "CG-P": {
    "bbox": [
      13.8603,
      -4.9221,
      16.2146,
      -2.7135
    ]
  },
  "NC:NP": {
    "bbox": [
      162.801,
      -21.6406,
      166.4148,
      -18.6521
    ]
  },
  "NC:SP": {
    "bbox": [
      164.8698,
      -23.2218,
      167.811,
      -21.3354
    ]
  },
  "SL2": {
    "bbox": [
      -12.6479,
      7.3387,
      -10.2717,
      10
    ]
  },
  "SL1": {
    "bbox": [
      -13.3021,
      6.9216,
      -11.1412,
      9.9402
    ]
  },
  "LK-4": {
    "bbox": [
      79.3959,
      8.5244,
      81.1271,
      10.035
    ]
  },
  "IQ-B": {
    "bbox": [
      42.3353,
      32.6019,
      46.0082,
      35.1106
    ]
  },
  "IQ-S": {
    "bbox": [
      43.257,
      29.1196,
      49.1068,
      33.4891
    ]
  },
  "MG-D": {
    "bbox": [
      47.8583,
      -15.9971,
      50.4861,
      -11.952
    ]
  },
  "IN-TG": {
    "bbox": [
      77.2366,
      15.8363,
      81.3219,
      19.9173
    ]
  },
  "TJ-SU": {
    "bbox": [
      67.3333,
      38.9222,
      70.892,
      41.0451
    ]
  },
  "TJ-GB": {
    "bbox": [
      70.2556,
      36.6711,
      75.154,
      39.4743
    ]
  },
  "TJ-1": {
    "bbox": [
      68.0567,
      37.8517,
      72.232,
      39.6115
    ]
  },
  "TJ-KT": {
    "bbox": [
      67.7772,
      36.9257,
      70.49,
      38.7928
    ]
  },
  "ET-SI": {
    "bbox": [
      37.9064,
      6.1388,
      39.1327,
      7.1657
    ]
  },
  "GN:MG": {
    "bbox": [
      -14.0812,
      9.8723,
      -11.0508,
      12.6756
    ]
  },
  "GN:MR": {
    "bbox": [
      -15.3667,
      9.0341,
      -12.1101,
      11.677
    ]
  },
  "GH:N": {
    "bbox": [
      -2.9414,
      8.1464,
      0.4177,
      11.1749
    ]
  },
  "GH:A": {
    "bbox": [
      -3.2608,
      5.3264,
      0.1497,
      8.7879
    ]
  },
  "ZW-3": {
    "bbox": [
      29.7345,
      -22.4241,
      33.0684,
      -17.2484
    ]
  },
  "ZW-2": {
    "bbox": [
      25.2373,
      -22.3563,
      31.1213,
      -16.866
    ]
  },
  "KE-W": {
    "bbox": [
      33.9097,
      -1.3894,
      35.3433,
      1.1449
    ]
  },
  "KE-700": {
    "bbox": [
      33.9878,
      -3.1961,
      38.0793,
      4.62
    ]
  },
  "MW-C": {
    "bbox": [
      32.6719,
      -15.3297,
      34.9744,
      -12.1586
    ]
  },
  "MW-S": {
    "bbox": [
      34.2491,
      -17.1296,
      35.9186,
      -13.4831
    ]
  },
  "MW-N": {
    "bbox": [
      32.9404,
      -12.7302,
      34.7944,
      -9.3683
    ]
  },
  "MR-3": {
    "bbox": [
      -14.3012,
      15.4998,
      -4.8333,
      27.3149
    ]
  },
  "MR-1": {
    "bbox": [
      -17.0681,
      16.0553,
      -12.669,
      21.3417
    ]
  },
  "MR-2": {
    "bbox": [
      -14.9548,
      14.721,
      -8.2892,
      18.557
    ]
  },
  "GN:GF": {
    "bbox": [
      -10.7019,
      7.1906,
      -7.6379,
      9.5855
    ]
  },
  "GN:HG": {
    "bbox": [
      -11.5996,
      8.5721,
      -7.9451,
      12.5062
    ]
  },
  "PM-M": {
    "bbox": [
      -56.6975,
      46.6293,
      -56.105,
      47.3416
    ]
  },
  "PM-P": {
    "bbox": [
      -56.5395,
      46.5488,
      -55.9066,
      46.8852
    ]
  },
  "PT:N": {
    "bbox": [
      -8.881,
      41.0014,
      -6.1892,
      42.1543
    ]
  },
  "KE-400": {
    "bbox": [
      36.0493,
      -3.0708,
      39.4629,
      4.4551
    ]
  },
  "KE-30": {
    "bbox": [
      36.6509,
      -1.4445,
      37.1039,
      -1.1635
    ]
  },
  "KE-500": {
    "bbox": [
      38.6583,
      -2.0399,
      41.9068,
      4.2849
    ]
  },
  "KE-200": {
    "bbox": [
      36.2015,
      -1.3057,
      37.4961,
      0.1374
    ]
  },
  "KE-300": {
    "bbox": [
      37.5854,
      -4.7996,
      41.5594,
      -0.004
    ]
  },
  "GH:V": {
    "bbox": [
      -2.258,
      6.148,
      0.7315,
      10.359
    ]
  },
  "PH-V": {
    "bbox": [
      121.1451,
      8.9028,
      126.1051,
      12.8294
    ]
  },
  "AR-X": {
    "bbox": [
      -65.7713,
      -35.0154,
      -61.7716,
      -29.5004
    ]
  },
  "CI:SF": {
    "bbox": [
      -8.6015,
      4.3612,
      -4.9364,
      8.157
    ]
  },
  "SA-04": {
    "bbox": [
      44.646,
      19.0005,
      55.6667,
      29.1593
    ]
  },
  "SA-S": {
    "bbox": [
      41.3657,
      16.3795,
      52.0018,
      20.8027
    ]
  },
  "SA-B": {
    "bbox": [
      37.0062,
      27.9308,
      45.172,
      32.1543
    ]
  },
  "SA-N": {
    "bbox": [
      39.1142,
      19.2083,
      48.2582,
      29.2079
    ]
  },
  "SA-H": {
    "bbox": [
      34.4944,
      18.2812,
      43.8302,
      29.9756
    ]
  },
  "NG-NEZ": {
    "bbox": [
      8.7492,
      6.5,
      14.678,
      13.7214
    ]
  },
  "NG-NWZ": {
    "bbox": [
      3.4763,
      9.0006,
      10.6021,
      13.8856
    ]
  },
  "NG-SEZ": {
    "bbox": [
      6.634,
      4.823,
      8.4548,
      7.1037
    ]
  },
  "NG-SSZ": {
    "bbox": [
      4.9768,
      4.2651,
      9.4744,
      7.5914
    ]
  },
  "NG-NCZ": {
    "bbox": [
      2.7293,
      6.4416,
      10.64,
      11.3733
    ]
  },
  "NG-SWZ": {
    "bbox": [
      2.6769,
      5.8874,
      6.0042,
      9.1883
    ]
  },
  "TL-OE": {
    "bbox": [
      124.0416,
      -9.5042,
      124.4829,
      -9.1669
    ]
  },
  "EG.ME": {
    "bbox": [
      28.6251,
      26.1918,
      32.7987,
      29.4362
    ]
  },
  "AZ-1": {
    "bbox": [
      45.0138,
      38.393,
      51.1766,
      41.9647
    ]
  },
  "AZ-K": {
    "bbox": [
      46.4576,
      39.3825,
      47.7778,
      40.5507
    ]
  },
  "UG-N": {
    "bbox": [
      30.7401,
      1.3652,
      35.0003,
      4.2341
    ]
  },
  "UG-E": {
    "bbox": [
      32.8195,
      -1,
      34.8315,
      2.4189
    ]
  },
  "UG-C": {
    "bbox": [
      31.0124,
      -1,
      33.5207,
      1.678
    ]
  },
  "UG-W": {
    "bbox": [
      29.5734,
      -1.4823,
      32.3629,
      2.3719
    ]
  },
  "TO-02": {
    "bbox": [
      -175.621,
      -20.7702,
      -174.0532,
      -19.3917
    ]
  },
  "TO3": {
    "bbox": [
      -175.8854,
      -19.4092,
      -173.5295,
      -15.3656
    ]
  },
  "TO1": {
    "bbox": [
      -176.4338,
      -22.5491,
      -174.6854,
      -20.8131
    ]
  },
  "BS:S": {
    "bbox": [
      -78.747,
      20.706,
      -72.5795,
      25.506
    ]
  },
  "SD-D": {
    "bbox": [
      21.8144,
      9.4889,
      27.9072,
      20.0014
    ]
  },
  "SD-K": {
    "bbox": [
      26.9365,
      9.3439,
      32.4697,
      16.5739
    ]
  },
  "SD-E": {
    "bbox": [
      32.9433,
      9.5,
      37.0228,
      17.1187
    ]
  },
  "SD-N": {
    "bbox": [
      25,
      16.033,
      39.0576,
      22.2249
    ]
  },
  "SD-C": {
    "bbox": [
      31.5523,
      11.9511,
      34.4035,
      16.6313
    ]
  },
  "BS:N": {
    "bbox": [
      -80.7002,
      22.84,
      -75.3102,
      27.4735
    ]
  },
  "PH-MW": {
    "bbox": [
      117.9667,
      4.4256,
      125.5583,
      9.3931
    ]
  },
  "PG-NSB": {
    "bbox": [
      154,
      -7.0975,
      159.6935,
      -2.9059
    ]
  },
  "PG-NB": {
    "bbox": [
      147.5,
      -6.7891,
      154,
      -4
    ]
  },
  "PG-IM": {
    "bbox": [
      142.1875,
      -5,
      154,
      -0.5574
    ]
  },
  "PK-JK": {
    "bbox": [
      73.3903,
      32.7701,
      74.9357,
      35.155
    ]
  },
  "PK-KP": {
    "bbox": [
      69.2378,
      31.0668,
      74.1265,
      36.9088
    ]
  },
  "OM2": {
    "bbox": [
      55,
      17.859,
      60.0546,
      24.004
    ]
  },
  "OM1": {
    "bbox": [
      55.3705,
      22.8992,
      59.3753,
      25.0088
    ]
  },
  "OM-ZU": {
    "bbox": [
      52,
      16.465,
      56.6099,
      20
    ]
  },
  "OM-MU": {
    "bbox": [
      55.8884,
      25.2272,
      56.7715,
      26.7027
    ]
  },
  "JP:G": {
    "bbox": [
      131.8804,
      32.3845,
      134.9869,
      34.6286
    ]
  },
  "JP-01": {
    "bbox": [
      139.0673,
      41.1521,
      145.916,
      45.7112
    ]
  },
  "ID-BB": {
    "bbox": [
      104.9996,
      -4.9994,
      109.3898,
      -0.2733
    ]
  },
  "ID-KR": {
    "bbox": [
      103.0646,
      -1.1825,
      109.7127,
      4.9966
    ]
  },
  "HN-C": {
    "bbox": [
      -87.8023,
      14.6158,
      -82.1816,
      16.3588
    ]
  },
  "FM-YAP": {
    "bbox": [
      137.1344,
      6.4768,
      147.8507,
      10.2933
    ]
  },
  "FM-TRK": {
    "bbox": [
      148.9657,
      5.0809,
      154.024,
      9.189
    ]
  },
  "FM-KSA": {
    "bbox": [
      162.6972,
      5.0574,
      163.2375,
      5.576
    ]
  },
  "FM-PNI": {
    "bbox": [
      154.0394,
      0.8233,
      160.9194,
      8.3487
    ]
  },
  "BD-4": {
    "bbox": [
      90.5393,
      20.3679,
      92.6803,
      25.2073
    ]
  },
  "BD-3": {
    "bbox": [
      88.5543,
      21.41,
      91.0312,
      24.2068
    ]
  },
  "CV-B": {
    "bbox": [
      -25.5731,
      15.5465,
      -22.4548,
      17.4071
    ]
  },
  "CV-S": {
    "bbox": [
      -24.9653,
      14.6066,
      -22.6955,
      16.3754
    ]
  },
  "BD-2": {
    "bbox": [
      88.0079,
      23.8071,
      89.8873,
      26.6383
    ]
  },
  "PH-ME": {
    "bbox": [
      125.0522,
      5.2297,
      126.7387,
      10.6084
    ]
  },
  "IS-R": {
    "bbox": [
      -22.7538,
      63.7999,
      -21.1628,
      64.3808
    ]
  },
  "PT:C": {
    "bbox": [
      -9.5498,
      39.2116,
      -6.781,
      41.2147
    ]
  },
  "BD-1": {
    "bbox": [
      89.3012,
      22.8457,
      91.2488,
      25.4322
    ]
  },
  "IS-E": {
    "bbox": [
      -21.9131,
      63.2961,
      -13.4948,
      65.9659
    ]
  },
  "IS-A": {
    "bbox": [
      -24.532,
      64.2981,
      -14.5299,
      67.1509
    ]
  },
  "VC:0": {
    "bbox": [
      -61.5293,
      13.0703,
      -60.9088,
      13.5843
    ]
  },
  "VC-06": {
    "bbox": [
      -61.6646,
      12.3984,
      -60.9159,
      13.1058
    ]
  },
  "TC:T": {
    "bbox": [
      -71.5957,
      20.9702,
      -70.8644,
      21.7796
    ]
  },
  "TC:C": {
    "bbox": [
      -72.6799,
      20.9553,
      -71.1727,
      22.1631
    ]
  },
  "MX-SLP": {
    "bbox": [
      -102.296,
      21.1597,
      -98.326,
      24.4915
    ]
  },
  "MY:2": {
    "bbox": [
      101.3316,
      2.4583,
      104.2233,
      6.2473
    ]
  },
  "ST-P": {
    "bbox": [
      7.2816,
      1.3398,
      7.47,
      1.7259
    ]
  },
  "HN-IB": {
    "bbox": [
      -87.3037,
      15.8925,
      -83.693,
      17.6195
    ]
  },
  "HN-P": {
    "bbox": [
      -87.8295,
      12.9808,
      -86.7041,
      13.8516
    ]
  },
  "HN-H": {
    "bbox": [
      -89.3568,
      13.5013,
      -84.9999,
      16.1638
    ]
  },
  "LK-5": {
    "bbox": [
      80.753,
      6.384,
      82.081,
      9.1103
    ]
  },
  "LK1": {
    "bbox": [
      79.4907,
      5.719,
      81.8676,
      8.9202
    ]
  },
  "TL-N": {
    "bbox": [
      124.9318,
      -9.2135,
      126.8118,
      -8.4148
    ]
  },
  "TL-S": {
    "bbox": [
      124.9819,
      -9.4627,
      127.3421,
      -8.3216
    ]
  },
  "FJ-VL": {
    "bbox": [
      174.4215,
      -21.9434,
      178.8687,
      -16.2277
    ]
  },
  "FJ-E": {
    "bbox": [
      -180,
      -21.2287,
      180,
      -16.6793
    ]
  },
  "FJ-N": {
    "bbox": [
      -180,
      -17.3288,
      180,
      -15.5078
    ]
  },
  "ST-ST": {
    "bbox": [
      6.4602,
      -0.0139,
      6.761,
      0.4134
    ]
  },
  "MA-03": {
    "bbox": [
      -5.8831,
      32.6006,
      -2.899,
      34.8875
    ]
  },
  "PT:A": {
    "bbox": [
      -9.263,
      37.3189,
      -6.9315,
      39.8387
    ]
  },
  "TT-TOB": {
    "bbox": [
      -60.8457,
      11.1341,
      -60.5176,
      11.3467
    ]
  },
  "IN-LA": {
    "bbox": [
      75.327,
      32.3357,
      79.4608,
      35.6745
    ]
  },
  "CD-3": {
    "bbox": [
      26.8106,
      -5.0103,
      29.9873,
      0.9542
    ]
  },
  "SR:R": {
    "bbox": [
      -58.0712,
      1.8313,
      -53.98,
      5.7014
    ]
  },
  "SR:E": {
    "bbox": [
      -55.3585,
      5.2339,
      -53.8601,
      6.195
    ]
  },
  "SR:W": {
    "bbox": [
      -57.3414,
      5.2199,
      -55.2826,
      6.2161
    ]
  },
  "LA:S": {
    "bbox": [
      104.7333,
      13.9097,
      107.635,
      17.1234
    ]
  },
  "LA:N": {
    "bbox": [
      100.0843,
      17.466,
      103.4005,
      22.5087
    ]
  },
  "LA:C": {
    "bbox": [
      101.3862,
      16.9017,
      106.426,
      20.9766
    ]
  },
  "MM-S": {
    "bbox": [
      93.0125,
      13.7719,
      97.2244,
      19.4933
    ]
  },
  "MM-W": {
    "bbox": [
      92.1729,
      17.3361,
      94.9018,
      24.1054
    ]
  },
  "MM-N": {
    "bbox": [
      93.9432,
      21.576,
      98.7822,
      28.5478
    ]
  },
  "MM-E": {
    "bbox": [
      96.1511,
      18.4911,
      101.1701,
      24.1591
    ]
  },
  "MM-SE": {
    "bbox": [
      96.3916,
      9.5261,
      99.6649,
      19.5091
    ]
  },
  "MM-C": {
    "bbox": [
      93.8455,
      18.832,
      96.896,
      23.6838
    ]
  },
  "PF:G": {
    "bbox": [
      -137.3588,
      -23.5756,
      -134.2448,
      -21.0932
    ]
  },
  "PF:T": {
    "bbox": [
      -148.9238,
      -23.5756,
      -134.2448,
      -13.8907
    ]
  },
  "GY:C": {
    "bbox": [
      -60.7204,
      5.844,
      -57.5275,
      8.5501
    ]
  },
  "GY:H": {
    "bbox": [
      -61.3827,
      1.171,
      -57.9493,
      7.2026
    ]
  },
  "GY:B": {
    "bbox": [
      -58.9074,
      1.456,
      -56.469,
      6.5018
    ]
  },
  "FJ-R": {
    "bbox": [
      176.7296,
      -12.7325,
      177.3516,
      -12.2614
    ]
  },
  "KI-P": {
    "bbox": [
      -174.7434,
      -4.896,
      -170.5075,
      -2.565
    ]
  },
  "KI-L": {
    "bbox": [
      -160.61,
      -11.646,
      -149.9925,
      4.9
    ]
  },
  "MX-NAY": {
    "bbox": [
      -106.7032,
      20.6032,
      -103.7209,
      23.0845
    ]
  },
  "AG-10": {
    "bbox": [
      -62.3766,
      17.272,
      -61.4946,
      17.9473
    ]
  },
  "AG:A": {
    "bbox": [
      -62.5548,
      16.7556,
      -61.4476,
      17.433
    ]
  },
  "BN-TE": {
    "bbox": [
      115.022,
      4.2962,
      115.3636,
      4.9622
    ]
  },
  "GL-SW": {
    "bbox": [
      -55.6133,
      59.5154,
      -41.2533,
      70.3742
    ]
  },
  "GL-NW": {
    "bbox": [
      -74.125,
      68.8853,
      -44,
      81.455
    ]
  },
  "GL-E": {
    "bbox": [
      -63.4406,
      62.5751,
      -11.0277,
      83.7253
    ]
  },
  "AU-LDH": {
    "bbox": [
      159.0369,
      -31.5979,
      159.1054,
      -31.5107
    ]
  },
  "IN-UT": {
    "bbox": [
      77.5713,
      28.7243,
      81.0309,
      31.459
    ]
  },
  "NO-42": {
    "bbox": [
      6.1497,
      57.759,
      9.6689,
      59.6727
    ]
  },
  "WF-F": {
    "bbox": [
      -178.3874,
      -14.5631,
      -177.7953,
      -14.0398
    ]
  },
  "IQ-D": {
    "bbox": [
      38.7937,
      29.0586,
      46.7487,
      33.9129
    ]
  },
  "IN-GA": {
    "bbox": [
      73.6756,
      14.7529,
      74.3379,
      15.8008
    ]
  },
  "NZ-STW": {
    "bbox": [
      167.026,
      -47.724,
      168.5672,
      -46.5235
    ]
  },
  "WF-W": {
    "bbox": [
      -176.4555,
      -13.5913,
      -175.919,
      -12.9828
    ]
  },
  "WS-S": {
    "bbox": [
      -173.0092,
      -14.0036,
      -171.9785,
      -13.2382
    ]
  },
  "WS-U": {
    "bbox": [
      -172.3526,
      -14.2771,
      -171.1929,
      -13.5925
    ]
  },
  "ET-SW": {
    "bbox": [
      34.186,
      5.3348,
      37.5329,
      8.0836
    ]
  },
  "KY:SI": {
    "bbox": [
      -80.3227,
      19.457,
      -79.5111,
      19.9574
    ]
  },
  "KY:GC": {
    "bbox": [
      -81.6314,
      19.0621,
      -80.8731,
      19.5969
    ]
  },
  "ID-PD": {
    "bbox": [
      129.0848,
      -2.9766,
      133.5218,
      1.2874
    ]
  },
  "GF:SG": {
    "bbox": [
      -53.3444,
      2.1673,
      -51.6346,
      4.7891
    ]
  },
  "PF:S": {
    "bbox": [
      -154.935,
      -18.0844,
      -147.8499,
      -15.5969
    ]
  },
  "timestamp": 1750590055
};
